/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import _, { throttle } from 'lodash';
import NavigationBar from '../components/NavBar'
import Cells from '../components/validation report/Cells'
import BottomCells from '../components/validation report/BottomCells'
import SumsCells from '../components/validation report/SumsCells'
import Dropdown from 'react-dropdown'
import { CSVLink, CSVDownload } from "react-csv"
import RentalClock from '../clock/rentalClock'

// objects for pushing
var sundayObj = {
    DpmoBonus: 0,
    Missortfourth: 0,
    missortsixth: 0,
    R2: 0,
    R4: 0,
    R6: 0,
    miles: 0,
    support: 0,
    totalLVP: 0,
    totalLwp: 0,
    totalTraining: 0
}
var mondayObj = {
    DpmoBonus: 0,
    Missortfourth: 0,
    missortsixth: 0,
    R2: 0,
    R4: 0,
    R6: 0,
    miles: 0,
    support: 0,
    totalLVP: 0,
    totalLwp: 0,
    totalTraining: 0
}
var tuesdayObj = {
    DpmoBonus: 0,
    Missortfourth: 0,
    missortsixth: 0,
    R2: 0,
    R4: 0,
    R6: 0,
    miles: 0,
    support: 0,
    totalLVP: 0,
    totalLwp: 0,
    totalTraining: 0
}
var wednesdayObj = {
    DpmoBonus: 0,
    Missortfourth: 0,
    missortsixth: 0,
    R2: 0,
    R4: 0,
    R6: 0,
    miles: 0,
    support: 0,
    totalLVP: 0,
    totalLwp: 0,
    totalTraining: 0
}
var thursdayObj = {
    DpmoBonus: 0,
    Missortfourth: 0,
    missortsixth: 0,
    R2: 0,
    R4: 0,
    R6: 0,
    miles: 0,
    support: 0,
    totalLVP: 0,
    totalLwp: 0,
    totalTraining: 0
}
var fridayObj = {
    DpmoBonus: 0,
    Missortfourth: 0,
    missortsixth: 0,
    R2: 0,
    R4: 0,
    R6: 0,
    miles: 0,
    support: 0,
    totalLVP: 0,
    totalLwp: 0,
    totalTraining: 0
}
var saturdayObj = {
    DpmoBonus: 0,
    Missortfourth: 0,
    missortsixth: 0,
    R2: 0,
    R4: 0,
    R6: 0,
    miles: 0,
    support: 0,
    totalLVP: 0,
    totalLwp: 0,
    totalTraining: 0
}


var myInterval;

//// reports page
const Statistics = (props) => {
    // state for styling the text box -> messageBox
    const [textState, setTextState] = useState('messageBox')

    // change the box size
    const handleChangeBoxSize = () => {
        textState === 'messageBoxBig' ? setTextState('messageBox') : setTextState('messageBoxBig')
    }

    useEffect( () => {
        if (props.superUser) {

        } else {
            async function postData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            async function putData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            postData('https://backendpajamas.herokuapp.com/tracker/', {
                ID: props.user_id
            }).then( response => {
                let theDate = new Date()
                let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
                if (response.data) {
                    response.data.forEach( ele => {
                        if (ele.date === new Date().toDateString()) {
                            let localPagesList = [...ele.pages_list, `${ele.pages_list.length}+validation+${theTime}`]
                            putData(`https://backendpajamas.herokuapp.com/trackeradditions/${ele._id}/`, {
                                pages_list: localPagesList
                            })
                        }
                    })
                }
            })
        }
    }, [])

    // handle locking the page
    const handleLock = () => {
        if (lockText === 'Lock') {
            getData('https://backendpajamas.herokuapp.com/validationlock/').then( response => {
                if (response.results.length > 0) {
                    let isFound = false
                    response.results.forEach( ele => {
                        if (new Date(ele.date).getWeek() === sunday.getWeek()) { 
                            isFound = true
                            putData(`https://backendpajamas.herokuapp.com/validationlock/${ele.validation_id}/`, {
                                overriden: false
                            }).then( response => {
                                setLockDiv('lockDivValidation')
                                setLockText('Unlock')
                                setTitleText('(locked)')
                            })
                        }
                    })
                    if (!isFound) {
                        postData('https://backendpajamas.herokuapp.com/validationlock/', {
                            date: sunday.toDateString()
                        }).then( response => {
                            setLockDiv('lockDivValidation')
                            setLockText('Unlock')
                            setTitleText('(locked)')
                        })
                    }
                } else {
                    postData('https://backendpajamas.herokuapp.com/validationlock/', {
                        date: sunday.toDateString()
                    }).then( response => {
                        setLockDiv('lockDivValidation')
                        setLockText('Unlock')
                        setTitleText('(locked)')
                    })
                }
            })
        } else {
            getData('https://backendpajamas.herokuapp.com/validationlock/').then( response => {
                if (response.results.length > 0) {
                    response.results.forEach( ele => {
                        if (new Date(ele.date).getWeek() === sunday.getWeek()) {
                            putData(`https://backendpajamas.herokuapp.com/validationlock/${ele.validation_id}/`, {
                                overriden: true
                            }).then( response => {
                                setTimeLockBool(true)
                                setLockDiv('')
                                setLockText('Lock')
                                setTitleText('')
                                if (sunday.getWeek() < new Date().getWeek()) {
                                    postData('https://backendpajamas.herokuapp.com/eighthour/', {
                                        date: new Date(ele.date).getWeek(),
                                        locktype: 'https://backendpajamas.herokuapp.com/validationlock/',
                                        lockid: ele.validation_id,
                                        current_date: new Date()
                                    }).then( response => {
                                        console.log('will lock in 8 hours')
                                    })
                                }
                            })
                        }
                    })
                }
            })
        }
    }

    // allow for encryption
    var CryptoJS = require("crypto-js");

    // routes for backend
    // POST
    async function postData(url = '', data = {}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'POST', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
            });

        return response ? response.json() : console.log('no reponse')
    };

    // delete
    async function deleteData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'DELETE', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            }
        });
    };

    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            }
        });

        return response ? response.json() : console.log('no reponse')
    };

    // PUT
    async function putData(url = '', data = {}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'PUT', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
            });

        return response ? response.json() : console.log('no reponse')
    };

    // get the week function
    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    // handling auto lock
    const [ currentDate, setCurrentDate ] = useState(new Date())
    const [ changedSelection, setChangedSelection ] = useState(false)
    const [ lockDiv, setLockDiv ] = useState('')
    const [ lockText, setLockText ] = useState('Lock')
    const [ titleText, setTitleText ] = useState('')
    const [ timeLockBool, setTimeLockBool ] = useState(false)

    // state to reduce csv changes
    const [csvRenderBool, setCsvRenderBool] = useState(false)
    const [csvRenderStatement, setCsvRenderStatement] = useState(null)

    // track the manager routes
    const [ managerRoutes, setManagerRoutes ] = useState(0)

    // local state
    const [ selectedDate, setSelectedDate ] = useState(new Date())

    // overall daily service data
    const [ data, setData ] = useState(null)

    // selected route/city sort
    const [ selectedCitySort, setSelectedCitySort ] = useState('DBS2')

    // state for sorted into state
    const [ mondaySorted, setMondaySorted ] = useState([])
    const [ tuesdaySorted, setTuesdaySorted ] = useState([])
    const [ wednesdaySorted, setWednesdaySorted ] = useState([])
    const [ thursdaySorted, setThursdaySorted ] = useState([])
    const [ fridaySorted, setFridaySorted ] = useState([])
    const [ saturdaySorted, setSaturdaySorted ] = useState([])
    const [ sundaySorted, setSundaySorted ] = useState([])

    // state for sorted into state
    const [ mondayRender, setMondayRender ] = useState([])
    const [ tuesdayRender, setTuesdayRender ] = useState([])
    const [ wednesdayRender, setWednesdayRender ] = useState([])
    const [ thursdayRender, setThursdayRender ] = useState([])
    const [ fridayRender, setFridayRender ] = useState([])
    const [ saturdayRender, setSaturdayRender ] = useState([])
    const [ sundayRender, setSundayRender ] = useState([])
    const [ totalRender, setTotalRender ] = useState([])

    // total data
    const [ totalMiles, setTotalMiles ] = useState(0)
    const [ totalRoutes, setTotalRoutes ] = useState(0)
    const [ totalLWP, setTotalLWP ] = useState(0)
    const [ totalVLP, setTotalLVP ] = useState(0)
    const [totalJumper, setTotalJumper] = useState(0)
    const [ totalTraining, setTotalTraining ] = useState(0)
    const [ totalSupport, setTotalSupport ] = useState(0)
    const [ totalR2, setTotalR2 ] = useState(0)
    const [ totalR4, setTotalR4 ] = useState(0)
    const [ totalR6, setTotalR6 ] = useState(0)

    // list of possible stations
    const [ list, setList ] = useState([])

    // sums
    const [ sumsRow, setSumsRow ] = useState([])

    // amazon data
    const [ totalAmazonRoutes, setTotalAmazonRoutes ] = useState(
        [
            [0,0,0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0,0,0]
        ]
    )

    // state for week change
    const [ sunday, setSunday ] = useState(new Date())
    const [ optionsThree, setOptionsThree ] = useState([])

    // state for bottom sums
    const [ amazonTotals, setAmazonTotals ] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]) 
    
    // data from the backend related to amazon saved data
    const [ amazonData, setAmazonData ] = useState([])
    const [ savedScreen, setSavedScreen ] = useState(null)

    // final sums only super user
    const [ finalSums, setFinalSums ] = useState(null)

    // excel data
    const [ xcelData, setXcelData ] = useState([])

        // excel data for h20
        const [ sundayH2oArray, setSundayH2oArray ] = useState([])
        const [ mondayH2oArray, setMondayH2oArray ] = useState([])
        const [ tuesdayH2oArray, setTuesdayH2oArray ] = useState([])
        const [ wednesdayH2oArray, setWednesdayH2oArray ] = useState([])
        const [ thursdayH2oArray, setThursdayH2oArray ] = useState([])
        const [ fridayH2oArray, setFridayH2oArray ] = useState([])
        const [ saturdayH2oArray, setSaturdayH2oArray ] = useState([])

    // messages
    const [ messages, setMessages ] = useState([])  
    const [ inputMessage, setInputMessage ] = useState('')
    const [ messageScreen, setMessageScreen ] = useState(null)
    const [ messageGate, setMessageGate ] = useState(false)
    const [ editGate, setEditGate ] = useState(false)
    const [ editMessage, setEditMessage ] = useState('')
    const [ editMessageDetails, setEditMessageDetails ] = useState(null)

    // handle checking for locked days
    useEffect( () => {
        getData('https://backendpajamas.herokuapp.com/validationlock/').then( response => {
            let localCheck = false
            response.results.forEach( ele => {
                if (new Date(ele.date).getWeek() === sunday.getWeek()) {
                    if (!ele.overriden) {
                        setLockDiv('lockDivValidation')
                        setLockText('Unlock')
                        setTitleText('(locked)')
                        localCheck = true
                    }
                }
            }) 
            if (!localCheck) {
                setLockDiv('')
                setLockText('Lock')
                setTitleText('')
            }
        })
    }, [sunday])
    
    // handling the clock
    useEffect( () => {
        clearInterval(myInterval)
        const timeFunction = () => {
            let setTime = () => {
                let localDate = new Date()
                let localFinalDate = localDate.setDate(localDate.getDate() + 8)
                if (localFinalDate < sunday && !timeLockBool && lockText !== "Lock") {
                    handleLock()
                }
                setCurrentDate(new Date())
            }
            myInterval = setInterval( setTime, 1000)
        }
        timeFunction()
    }, [])

    useEffect( () => {
        if (props.station) {
            if (props.station.length > 0) {
                setSelectedCitySort(props.station[0])
                // setSelectedCity()
            }
        }
    }, [])

    // allow for editing the messages
    const handleEdit = (e, message) => {
        e.preventDefault()
        e.stopPropagation()
        setEditMessage(message.message)
        setEditMessageDetails(message)
        setEditGate(true)
    }

    // map the input to state for message editing
    const handleChangeEditMessage = (e) => {
        setEditMessage(e.target.value)
    }

    // handle submitting the message edit
    const editMessageRequest = () => {
        putData(`https://backendpajamas.herokuapp.com/validationmessage/${editMessageDetails.message_id}/`, {
            message: editMessage
        }).then( response => {
            handleToggleMessageScreen()
            returnFromEditScreen()
        })  
    }

    // delete the message
    const deleteMessage = () => {
        deleteData(`https://backendpajamas.herokuapp.com/validationmessage/${editMessageDetails.message_id}/`)
        handleToggleMessageScreen()
        returnFromEditScreen()
    }

    // return from edit message screen
    const returnFromEditScreen = () => {
        setEditGate(false)
        setEditMessage('')
        setEditMessageDetails(null)
    }
    
    // allow for toggling the edit screen
    useEffect( () => {
        if (editGate) {
            setMessageScreen(
                <div className='messageScreenValidation'>
                    <div className='inputMessageBox'>
                        <textarea name="" id="" cols="30" rows="10" value={editMessage} onChange={handleChangeEditMessage}></textarea>
                    </div>
                    <div className='inputButtonBox'>
                        <button onClick={editMessageRequest}>Edit</button>
                        <button onClick={deleteMessage}>Delete</button>
                        <button onClick={returnFromEditScreen}>Cancel</button>
                    </div>
                </div>
            )
        } else {
            setMessageScreen(null)
        }
    }, [editGate, editMessage])

    
    // handling all message related activities
    useEffect( () => {
        setMessages([])
        getData('https://backendpajamas.herokuapp.com/validationmessage/').then( response => {
            let localArray = []
            response.results.forEach( messageLocal => {
                if (messageLocal.week_number === sunday.getWeek() && messageLocal.station === selectedCitySort) {
                    localArray.push(
                        <div className='messageTextContainer' onClick={(e) => handleEdit(e, messageLocal)}>
                            <h3>{messageLocal.name} | {new Date(messageLocal.date).toLocaleDateString('en-GB')}</h3>
                            <h4>{messageLocal.message}</h4>
                            <hr />
                        </div>
                    )
                }
            })
            setMessages(localArray)
            // response.forEach
        })
    }, [selectedCitySort, sunday, messageGate])

    // send the message
    const submitMessage = () => {
        postData('https://backendpajamas.herokuapp.com/validationmessage/', {
            station: selectedCitySort, 
            week_number: sunday.getWeek(),
            name: props.user_name,
            message: inputMessage,
            date: sunday.toDateString()
        }).then( response => {
            // response.forEach
            handleToggleMessageScreen()
        })
    }

    // toggle the screen
    const handleToggleMessageScreen = () => {
        messageGate ? setMessageGate(false) : setMessageGate(true)
    }

    // map the input to state for message
    const handleChangeInputMessage = (e) => {
        setInputMessage(e.target.value)
    }

    // make the submit screen
    useEffect( () => {
        if (messageGate) {
            setMessageScreen(
                <div className='messageScreenValidation'>
                    <div className='inputMessageBox'>
                        <textarea name="" id="" cols="30" rows="10" value={inputMessage} onChange={handleChangeInputMessage}></textarea>
                    </div>
                    <div className='inputButtonBox'>
                        <button onClick={submitMessage}>Submit</button>
                        <button onClick={handleToggleMessageScreen}>Cancel</button>
                    </div>
                </div>
            )
        } else {
            setMessageScreen(null)
        }
    }, [messageGate, inputMessage])

    // grab the data from the backend and map it into arrays
    useEffect( () => {
        // reset the sums
        setTotalMiles(0)
        setTotalRoutes(0)
        setTotalLWP(0)
        setTotalLVP(0)
        setTotalTraining(0)
        setTotalSupport(0)
        setTotalR2(0)
        setTotalR4(0)
        setTotalR6(0)
        setTotalJumper(0)

        // reset the amazon data
        setTotalAmazonRoutes(
            [
                [0,0,0,0,0,0,0,0,0,0,0,0,0 ],
                [0,0,0,0,0,0,0,0,0,0,0,0,0 ],
                [0,0,0,0,0,0,0,0,0,0,0,0,0 ],
                [0,0,0,0,0,0,0,0,0,0,0,0,0 ],
                [0,0,0,0,0,0,0,0,0,0,0,0,0 ],
                [0,0,0,0,0,0,0,0,0,0,0,0,0 ],
                [0,0,0,0,0,0,0,0,0,0,0,0,0 ]
            ]
        )

        // grab the saved data for the selected week
        postData('https://backendpajamas.herokuapp.com/validationsort/', {
            week: new Date(sunday).getWeek()
        }).then( response => {
            // set the data into state
            setAmazonData(response.data)
        })

        // get the weeks daily service data
        postData('https://backendpajamas.herokuapp.com/weekschedule/', {
            week: new Date(sunday).getWeek()
        }).then( response => {
            // get the weeks supports associated with the scheduled dates
            postData('https://backendpajamas.herokuapp.com/supportschedule/', {
                week: new Date(sunday).getWeek()
            }).then( responseSupport => {
                // map the support to the dates
                response.data.forEach( date => {
                    responseSupport.data.forEach( support => {
                        if (support.date_id === `https://backendpajamas.herokuapp.com/schedule/${date.date_id}/`) {
                            date.supportArray ? date.supportArray.push(support) : date.supportArray = [support]
                        }
                    })
                })
    
                // make an array of each day's scheduled dates
                let sundayArray = []
                let mondayArray = []
                let tuesdayArray = []
                let wednesdayArray = []
                let thursdayArray = []
                let fridayArray = []
                let saturdayArray = []
    
                if (response.data) {
                    let localManagerRoutes = 0
                    response.data.forEach( element => {
                        // allow for station mapping
                        if (element.location === selectedCitySort) {
                            if (element.route === 'Manager') {
                                localManagerRoutes++
                                setManagerRoutes(localManagerRoutes)
                            }
                            if (element.date.name !== 'bottomRoutes') {
                                switch (new Date(element.date).getDay()) {
                                    case 0:
                                        sundayArray.push(element)
                                        break;
                                    case 1:
                                        mondayArray.push(element)
                                        break;
                                    case 2:
                                        tuesdayArray.push(element)
                                        break;
                                    case 3:
                                        wednesdayArray.push(element)
                                        break;
                                    case 4:
                                        thursdayArray.push(element)
                                        break;
                                    case 5:
                                        fridayArray.push(element)
                                        break;
                                    case 6:
                                        saturdayArray.push(element)
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    })
                    setMondaySorted(mondayArray)
                    setTuesdaySorted(tuesdayArray)
                    setWednesdaySorted(wednesdayArray)
                    setThursdaySorted(thursdayArray)
                    setFridaySorted(fridayArray)
                    setSaturdaySorted(saturdayArray)
                    setSundaySorted(sundayArray)
                }
            })
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sunday, selectedCitySort])

    // map the backend amazon data
    useEffect( () => {
        if (amazonData) {
            amazonData.forEach( amazonObj => {
                if (amazonObj.station === selectedCitySort) {
                    switch (amazonObj.date) {
                        case 'Sunday':
                            totalAmazonRoutes[0][0] = amazonObj.routes ? amazonObj.routes : 0;
                            totalAmazonRoutes[0][1] = amazonObj.miles ? amazonObj.miles : 0;
                            totalAmazonRoutes[0][2] = amazonObj.totalLwp ? amazonObj.totalLwp : 0;
                            totalAmazonRoutes[0][3] = amazonObj.totalLVP ? amazonObj.totalLVP : 0;
                            totalAmazonRoutes[0][4] = amazonObj.totalTraining ? amazonObj.totalTraining : 0;
                            totalAmazonRoutes[0][5] = amazonObj.support ? amazonObj.support : 0;
                            totalAmazonRoutes[0][6] = amazonObj.R2 ? amazonObj.R2 : 0;
                            totalAmazonRoutes[0][7] = amazonObj.R4 ? amazonObj.R4 : 0;
                            totalAmazonRoutes[0][8] = amazonObj.R6 ? amazonObj.R6 : 0;
                            totalAmazonRoutes[0][9] = amazonObj.Missortfourth ? amazonObj.Missortfourth : 0;
                            totalAmazonRoutes[0][10] = amazonObj.Missortsixth ? amazonObj.Missortsixth : 0;
                            totalAmazonRoutes[0][11] = amazonObj.DpmoBonus ? amazonObj.DpmoBonus : 0;
                            totalAmazonRoutes[0][12] = amazonObj.Jumper ? amazonObj.Jumper : 0;
                            break;
                        case 'Monday':
                            totalAmazonRoutes[1][0] = amazonObj.routes ? amazonObj.routes : 0;
                            totalAmazonRoutes[1][1] = amazonObj.miles ? amazonObj.miles : 0;
                            totalAmazonRoutes[1][2] = amazonObj.totalLwp ? amazonObj.totalLwp : 0;
                            totalAmazonRoutes[1][3] = amazonObj.totalLVP ? amazonObj.totalLVP : 0;
                            totalAmazonRoutes[1][4] = amazonObj.totalTraining ? amazonObj.totalTraining : 0;
                            totalAmazonRoutes[1][5] = amazonObj.support ? amazonObj.support : 0;
                            totalAmazonRoutes[1][6] = amazonObj.R2 ? amazonObj.R2 : 0;
                            totalAmazonRoutes[1][7] = amazonObj.R4 ? amazonObj.R4 : 0;
                            totalAmazonRoutes[1][8] = amazonObj.R6 ? amazonObj.R6 : 0;
                            totalAmazonRoutes[1][9] = amazonObj.Missortfourth ? amazonObj.Missortfourth : 0;
                            totalAmazonRoutes[1][10] = amazonObj.Missortsixth ? amazonObj.Missortsixth : 0;
                            totalAmazonRoutes[1][11] = amazonObj.DpmoBonus ? amazonObj.DpmoBonus : 0;
                            totalAmazonRoutes[1][12] = amazonObj.Jumper ? amazonObj.Jumper : 0;
                            break;
                        case 'Tuesday':
                            totalAmazonRoutes[2][0] = amazonObj.routes ? amazonObj.routes : 0;
                            totalAmazonRoutes[2][1] = amazonObj.miles ? amazonObj.miles : 0;
                            totalAmazonRoutes[2][2] = amazonObj.totalLwp ? amazonObj.totalLwp : 0;
                            totalAmazonRoutes[2][3] = amazonObj.totalLVP ? amazonObj.totalLVP : 0;
                            totalAmazonRoutes[2][4] = amazonObj.totalTraining ? amazonObj.totalTraining : 0;
                            totalAmazonRoutes[2][5] = amazonObj.support ? amazonObj.support : 0;
                            totalAmazonRoutes[2][6] = amazonObj.R2 ? amazonObj.R2 : 0;
                            totalAmazonRoutes[2][7] = amazonObj.R4 ? amazonObj.R4 : 0;
                            totalAmazonRoutes[2][8] = amazonObj.R6 ? amazonObj.R6 : 0;
                            totalAmazonRoutes[2][9] = amazonObj.Missortfourth ? amazonObj.Missortfourth : 0;
                            totalAmazonRoutes[2][10] = amazonObj.Missortsixth ? amazonObj.Missortsixth : 0;
                            totalAmazonRoutes[2][11] = amazonObj.DpmoBonus ? amazonObj.DpmoBonus : 0;
                            totalAmazonRoutes[2][12] = amazonObj.Jumper ? amazonObj.Jumper : 0;
                            break;
                        case 'Wednesday':
                            totalAmazonRoutes[3][0] = amazonObj.routes ? amazonObj.routes : 0;
                            totalAmazonRoutes[3][1] = amazonObj.miles ? amazonObj.miles : 0;
                            totalAmazonRoutes[3][2] = amazonObj.totalLwp ? amazonObj.totalLwp : 0;
                            totalAmazonRoutes[3][3] = amazonObj.totalLVP ? amazonObj.totalLVP : 0;
                            totalAmazonRoutes[3][4] = amazonObj.totalTraining ? amazonObj.totalTraining : 0;
                            totalAmazonRoutes[3][5] = amazonObj.support ? amazonObj.support : 0;
                            totalAmazonRoutes[3][6] = amazonObj.R2 ? amazonObj.R2 : 0;
                            totalAmazonRoutes[3][7] = amazonObj.R4 ? amazonObj.R4 : 0;
                            totalAmazonRoutes[3][8] = amazonObj.R6 ? amazonObj.R6 : 0;
                            totalAmazonRoutes[3][9] = amazonObj.Missortfourth ? amazonObj.Missortfourth : 0;
                            totalAmazonRoutes[3][10] = amazonObj.Missortsixth ? amazonObj.Missortsixth : 0;
                            totalAmazonRoutes[3][11] = amazonObj.DpmoBonus ? amazonObj.DpmoBonus : 0;
                            totalAmazonRoutes[3][12] = amazonObj.Jumper ? amazonObj.Jumper : 0;
                            break;
                        case 'Thursday':
                            totalAmazonRoutes[4][0] = amazonObj.routes ? amazonObj.routes : 0;
                            totalAmazonRoutes[4][1] = amazonObj.miles ? amazonObj.miles : 0;
                            totalAmazonRoutes[4][2] = amazonObj.totalLwp ? amazonObj.totalLwp : 0;
                            totalAmazonRoutes[4][3] = amazonObj.totalLVP ? amazonObj.totalLVP : 0;
                            totalAmazonRoutes[4][4] = amazonObj.totalTraining ? amazonObj.totalTraining : 0;
                            totalAmazonRoutes[4][5] = amazonObj.support ? amazonObj.support : 0;
                            totalAmazonRoutes[4][6] = amazonObj.R2 ? amazonObj.R2 : 0;
                            totalAmazonRoutes[4][7] = amazonObj.R4 ? amazonObj.R4 : 0;
                            totalAmazonRoutes[4][8] = amazonObj.R6 ? amazonObj.R6 : 0;
                            totalAmazonRoutes[4][9] = amazonObj.Missortfourth ? amazonObj.Missortfourth : 0;
                            totalAmazonRoutes[4][10] = amazonObj.Missortsixth ? amazonObj.Missortsixth : 0;
                            totalAmazonRoutes[4][11] = amazonObj.DpmoBonus ? amazonObj.DpmoBonus : 0;
                            totalAmazonRoutes[4][12] = amazonObj.Jumper ? amazonObj.Jumper : 0;
                            break;
                        case 'Friday':
                            totalAmazonRoutes[5][0] = amazonObj.routes ? amazonObj.routes : 0;
                            totalAmazonRoutes[5][1] = amazonObj.miles ? amazonObj.miles : 0;
                            totalAmazonRoutes[5][2] = amazonObj.totalLwp ? amazonObj.totalLwp : 0;
                            totalAmazonRoutes[5][3] = amazonObj.totalLVP ? amazonObj.totalLVP : 0;
                            totalAmazonRoutes[5][4] = amazonObj.totalTraining ? amazonObj.totalTraining : 0;
                            totalAmazonRoutes[5][5] = amazonObj.support ? amazonObj.support : 0;
                            totalAmazonRoutes[5][6] = amazonObj.R2 ? amazonObj.R2 : 0;
                            totalAmazonRoutes[5][7] = amazonObj.R4 ? amazonObj.R4 : 0;
                            totalAmazonRoutes[5][8] = amazonObj.R6 ? amazonObj.R6 : 0;
                            totalAmazonRoutes[5][9] = amazonObj.Missortfourth ? amazonObj.Missortfourth : 0;
                            totalAmazonRoutes[5][10] = amazonObj.Missortsixth ? amazonObj.Missortsixth : 0;
                            totalAmazonRoutes[5][11] = amazonObj.DpmoBonus ? amazonObj.DpmoBonus : 0;
                            totalAmazonRoutes[5][12] = amazonObj.Jumper ? amazonObj.Jumper : 0;
                            break;
                        case 'Saturday':
                            totalAmazonRoutes[6][0] = amazonObj.routes ? amazonObj.routes : 0;
                            totalAmazonRoutes[6][1] = amazonObj.miles ? amazonObj.miles : 0;
                            totalAmazonRoutes[6][2] = amazonObj.totalLwp ? amazonObj.totalLwp : 0;
                            totalAmazonRoutes[6][3] = amazonObj.totalLVP ? amazonObj.totalLVP : 0;
                            totalAmazonRoutes[6][4] = amazonObj.totalTraining ? amazonObj.totalTraining : 0;
                            totalAmazonRoutes[6][5] = amazonObj.support ? amazonObj.support : 0;
                            totalAmazonRoutes[6][6] = amazonObj.R2 ? amazonObj.R2 : 0;
                            totalAmazonRoutes[6][7] = amazonObj.R4 ? amazonObj.R4 : 0;
                            totalAmazonRoutes[6][8] = amazonObj.R6 ? amazonObj.R6 : 0;
                            totalAmazonRoutes[6][9] = amazonObj.Missortfourth ? amazonObj.Missortfourth : 0;
                            totalAmazonRoutes[6][10] = amazonObj.Missortsixth ? amazonObj.Missortsixth : 0;
                            totalAmazonRoutes[6][11] = amazonObj.DpmoBonus ? amazonObj.DpmoBonus : 0;
                            totalAmazonRoutes[6][12] = amazonObj.Jumper ? amazonObj.Jumper : 0;
                            break;
                        default:
                            break;
                    }
                }
            })
        }
        mapAmazonDataFromBackend()
    }, [amazonData, sunday])

    // monday change
    useEffect( () => {
        // local arrays for rendering
        let renderingMonday = []

        // local data
        let routeAmount = 0
        let miles = 0
        let LWP = 0
        let LVP = 0
        let Training = 0
        let supportLocal = 0
        let R2 = 0
        let R4 = 0
        let R6 = 0
        let jumper = 0

        mondaySorted.forEach( sortedDate => {
            // add the mileage
            miles += sortedDate.finish_mileage

            // sweeper
            // if (sortedDate.route === 'Sweeper') {
            //     routeAmount += 1
            // }
            
            // add the overall route count if not training
            if (sortedDate.route !== "0" && sortedDate.route !== 'Classroom Training' && sortedDate.route !== "Rescue Payment" && sortedDate.route !== "None" && sortedDate.route !== 'Manager' && sortedDate.route !== 'Ride Along' && sortedDate.route !== 'Jumper') {

                if (sortedDate.route === 'Half Standard Van Route') {
                    routeAmount += 0.5

                } else {
                    // increment total routes
                    routeAmount += 1
                }

                // increment lvp for large van routes
                if (sortedDate.route === 'Full Large Van Route') {
                    LVP += 1
                }

            }
            // increment the jumper amount
            if (sortedDate.route === 'Jumper') {
                jumper += 1
            }

            // add the training
            if (sortedDate.route === 'Classroom Training' || sortedDate.route === 'Ride Along') {
                Training++
            }

            // add the support, handle late wave payments
            if (sortedDate.supportArray) {
                sortedDate.supportArray.forEach( support => {
                    switch (support.name) {
                        case 'Late Wave Payment':
                            LWP += (parseInt(support.amount)/10)
                            break;
                        case 'R2':
                            R2 += 1;
                            break;
                        case 'R4':
                            R4 += 1;
                            break;
                        case 'R6':
                            R6 += 1;
                            break;
                        default:
                            supportLocal += parseFloat(support.amount)
                    }
                })
            }
        })
        renderingMonday.push(
            <Cells 
                routeAmount={routeAmount}
                miles={miles}
                LWP={LWP}
                LVP={LVP}
                Training={Training}
                support={supportLocal}
                R2={R2}
                R4={R4}
                R6={R6}
                jumper={jumper}
                day={'Monday'}
            />
        )

        // map the data into the excel
        let sundayH2oObj = []
        sundayH2oObj.push('H2OL', routeAmount, miles, LWP, LVP, Training, jumper, supportLocal, R2, R4, R6, 0, 0, 0)
        setMondayH2oArray(sundayH2oObj)
                
        // calculate miles
        let localTotalMiles = totalMiles
        setTotalMiles(localTotalMiles += miles)

        // handle R2
        let localR2 = totalR2
        setTotalR2(localR2 += R2)

        // handle R2
        let localR4 = totalR4
        setTotalR4(localR4 += R4)

        // handle R2
        let localR6 = totalR6
        setTotalR6(localR6 += R6)

        // calculate routes
        let localTotalRoutes = totalRoutes
        setTotalRoutes(localTotalRoutes += routeAmount)

        // support total
        let localTotalSupport = totalSupport
        setTotalSupport(localTotalSupport += supportLocal)

        // set the training total
        let localTrainingAmount = totalTraining
        setTotalTraining(localTrainingAmount += Training)

        // increment LVP
        let localLVP = totalVLP
        setTotalLVP(localLVP += LVP)

        // increment LWP
        let localLWP = totalLWP
        setTotalLWP(localLWP += LWP)

        // handle the jumper
        let localJumper = totalJumper
        setTotalJumper(localJumper += jumper)

        setMondayRender(renderingMonday)
    }, [mondaySorted])

    // tuesday change
    useEffect( () => {
        // local arrays for rendering
        let renderingTuesday = []

        // local data
        let routeAmount = 0
        let miles = 0
        let LWP = 0
        let LVP = 0
        let Training = 0
        let supportLocal = 0
        let R2 = 0
        let R4 = 0
        let R6 = 0
        let jumper = 0

        tuesdaySorted.forEach( sortedDate => {
            // add the mileage
            miles += sortedDate.finish_mileage

            // sweeper
            // if (sortedDate.route === 'Sweeper') {
            //     routeAmount += 1
            // }
            
            // add the overall route count if not training
            if (sortedDate.route !== "0" && sortedDate.route !== 'Classroom Training' && sortedDate.route !== "None" && sortedDate.route !== "Rescue Payment" && sortedDate.route !== 'Manager' && sortedDate.route !== 'Ride Along' && sortedDate.route !== 'Jumper') {

                if (sortedDate.route === 'Half Standard Van Route') {
                    routeAmount += 0.5

                } else {
                    // increment total routes
                    routeAmount += 1
                }

                // increment lvp for large van routes
                if (sortedDate.route === 'Full Large Van Route') {
                    LVP += 1
                }

            }

            // increment lvp for large van routes
            if (sortedDate.route === 'Jumper') {
                jumper += 1
            }

            // add the training
            if (sortedDate.route === 'Classroom Training' || sortedDate.route === 'Ride Along') {
                Training++
            }

            // add the support, handle late wave payments
            if (sortedDate.supportArray) {
                sortedDate.supportArray.forEach( support => {
                    switch (support.name) {
                        case 'Late Wave Payment':
                            LWP += (parseInt(support.amount)/10)
                            break;
                        case 'R2':
                            R2 += 1;
                            break;
                        case 'R4':
                            R4 += 1;
                            break;
                        case 'R6':
                            R6 += 1;
                            break;
                        default:
                            supportLocal += parseFloat(support.amount)
                    }
                })
            }
        })
        renderingTuesday.push(
            <Cells 
                routeAmount={routeAmount}
                miles={miles}
                LWP={LWP}
                LVP={LVP}
                Training={Training}
                support={supportLocal}
                R2={R2}
                R4={R4}
                R6={R6}
                jumper={jumper}
                day={'Tuesday'}
            />
        )

        // map the data into the excel
        let sundayH2oObj = []
        sundayH2oObj.push('H2OL', routeAmount, miles, LWP, LVP, Training, jumper, supportLocal, R2, R4, R6, 0, 0, 0)
        setTuesdayH2oArray(sundayH2oObj)
               
        // calculate miles
        let localTotalMiles = totalMiles
        setTotalMiles(localTotalMiles += miles)

        // handle R2
        let localR2 = totalR2
        setTotalR2(localR2 += R2)

        // handle R2
        let localR4 = totalR4
        setTotalR4(localR4 += R4)

        // handle R2
        let localR6 = totalR6
        setTotalR6(localR6 += R6)

        // calculate routes
        let localTotalRoutes = totalRoutes
        setTotalRoutes(localTotalRoutes += routeAmount)

        // support total
        let localTotalSupport = totalSupport
        setTotalSupport(localTotalSupport += supportLocal)

        // set the training total
        let localTrainingAmount = totalTraining
        setTotalTraining(localTrainingAmount += Training)

        // increment LVP
        let localLVP = totalVLP
        setTotalLVP(localLVP += LVP)

        // increment LWP
        let localLWP = totalLWP
        setTotalLWP(localLWP += LWP)

        // increment jumper
        let localJumper = totalJumper
        setTotalJumper(localJumper += jumper)

        setTuesdayRender(renderingTuesday)
    }, [tuesdaySorted])

    // wednesday change
    useEffect( () => {
        // local arrays for rendering
        let renderingwednesday = []

        // local data
        let routeAmount = 0
        let miles = 0
        let LWP = 0
        let LVP = 0
        let Training = 0
        let supportLocal = 0
        let R2 = 0
        let R4 = 0
        let R6 = 0
        let jumper = 0

        wednesdaySorted.forEach( sortedDate => {
            // add the mileage
            miles += sortedDate.finish_mileage

            // sweeper
            // if (sortedDate.route === 'Sweeper') {
            //     routeAmount += 1
            // }
            
            // add the overall route count if not training
            if (sortedDate.route !== "0" && sortedDate.route !== 'Classroom Training' && sortedDate.route !== "None" && sortedDate.route !== "Rescue Payment" && sortedDate.route !== 'Manager' && sortedDate.route !== 'Ride Along' && sortedDate.route !== 'Jumper') {

                if (sortedDate.route === 'Half Standard Van Route') {
                    routeAmount += 0.5

                } else {
                    // increment total routes
                    routeAmount += 1
                }

                // increment lvp for large van routes
                if (sortedDate.route === 'Full Large Van Route') {
                    LVP += 1
                }

            }

            // increment jumper
            if (sortedDate.route === 'Jumper') {
                jumper += 1
            }

            // add the training
            if (sortedDate.route === 'Classroom Training' || sortedDate.route === 'Ride Along') {
                Training++
            }

            // add the support, handle late wave payments
            if (sortedDate.supportArray) {
                sortedDate.supportArray.forEach( support => {
                    switch (support.name) {
                        case 'Late Wave Payment':
                            LWP += (parseInt(support.amount)/10)
                            break;
                        case 'R2':
                            R2 += 1;
                            break;
                        case 'R4':
                            R4 += 1;
                            break;
                        case 'R6':
                            R6 += 1;
                            break;
                        default:
                            supportLocal += parseFloat(support.amount)
                    }
                })
            }
        })
        renderingwednesday.push(
            <Cells 
                routeAmount={routeAmount}
                miles={miles}
                LWP={LWP}
                LVP={LVP}
                Training={Training}
                support={supportLocal}
                R2={R2}
                R4={R4}
                R6={R6}
                jumper={jumper}
                day={'Wednesday'}
            />
        )

        // map the data into the excel
        let sundayH2oObj = []
        sundayH2oObj.push('H2OL', routeAmount, miles, LWP, LVP, Training, jumper, supportLocal, R2, R4, R6, 0, 0, 0)
        setWednesdayH2oArray(sundayH2oObj)
        
        // calculate miles
        let localTotalMiles = totalMiles
        setTotalMiles(localTotalMiles += miles)

        // handle R2
        let localR2 = totalR2
        setTotalR2(localR2 += R2)

        // handle R2
        let localR4 = totalR4
        setTotalR4(localR4 += R4)

        // handle R2
        let localR6 = totalR6
        setTotalR6(localR6 += R6)

        // calculate routes
        let localTotalRoutes = totalRoutes
        setTotalRoutes(localTotalRoutes += routeAmount)

        // support total
        let localTotalSupport = totalSupport
        setTotalSupport(localTotalSupport += supportLocal)

        // set the training total
        let localTrainingAmount = totalTraining
        setTotalTraining(localTrainingAmount += Training)

        // increment LVP
        let localLVP = totalVLP
        setTotalLVP(localLVP += LVP)

        // increment LWP
        let localLWP = totalLWP
        setTotalLWP(localLWP += LWP)

        // increment jumper
        let localJumper = totalJumper
        setTotalJumper(localJumper += jumper)

        setWednesdayRender(renderingwednesday)
    }, [wednesdaySorted])

    // thursday change
    useEffect( () => {
        // local arrays for rendering
        let renderingthursday = []

        // local data
        let routeAmount = 0
        let miles = 0
        let LWP = 0
        let LVP = 0
        let Training = 0
        let supportLocal = 0
        let R2 = 0
        let R4 = 0
        let R6 = 0
        let jumper = 0

        thursdaySorted.forEach( sortedDate => {
            // add the mileage
            miles += sortedDate.finish_mileage

            // sweeper
            // if (sortedDate.route === 'Sweeper') {
            //     routeAmount += 1
            // }
            
            // add the overall route count if not training
            if (sortedDate.route !== "0" && sortedDate.route !== 'Classroom Training' && sortedDate.route !== "None" && sortedDate.route !== "Rescue Payment" && sortedDate.route !== 'Manager' && sortedDate.route !== 'Ride Along' && sortedDate.route !== 'Jumper') {

                if (sortedDate.route === 'Half Standard Van Route') {
                    routeAmount += 0.5

                } else {
                    // increment total routes
                    routeAmount += 1
                }

                // increment lvp for large van routes
                if (sortedDate.route === 'Full Large Van Route') {
                    LVP += 1
                }

            }

            // increment Jumper
            if (sortedDate.route === 'Jumper') {
                jumper += 1
            }

            // add the training
            if (sortedDate.route === 'Classroom Training' || sortedDate.route === 'Ride Along') {
                Training++
            }

            // add the support, handle late wave payments
            if (sortedDate.supportArray) {
                sortedDate.supportArray.forEach( support => {
                    switch (support.name) {
                        case 'Late Wave Payment':
                            LWP += (parseInt(support.amount)/10)
                            break;
                        case 'R2':
                            R2 += 1;
                            break;
                        case 'R4':
                            R4 += 1;
                            break;
                        case 'R6':
                            R6 += 1;
                            break;
                        default:
                            supportLocal += parseFloat(support.amount)
                    }
                })
            }
        })
        renderingthursday.push(
            <Cells 
                routeAmount={routeAmount}
                miles={miles}
                LWP={LWP}
                LVP={LVP}
                Training={Training}
                support={supportLocal}
                R2={R2}
                R4={R4}
                R6={R6}
                jumper={jumper}
                day={'Thursday'}
            />
        )

        // map the data into the excel
        let sundayH2oObj = []
        sundayH2oObj.push('H2OL', routeAmount, miles, LWP, LVP, Training, jumper, supportLocal, R2, R4, R6, 0, 0, 0)
        setThursdayH2oArray(sundayH2oObj)
        
        // calculate miles
        let localTotalMiles = totalMiles
        setTotalMiles(localTotalMiles += miles)

        // handle R2
        let localR2 = totalR2
        setTotalR2(localR2 += R2)

        // handle R2
        let localR4 = totalR4
        setTotalR4(localR4 += R4)

        // handle R2
        let localR6 = totalR6
        setTotalR6(localR6 += R6)

        // calculate routes
        let localTotalRoutes = totalRoutes
        setTotalRoutes(localTotalRoutes += routeAmount)

        // support total
        let localTotalSupport = totalSupport
        setTotalSupport(localTotalSupport += supportLocal)

        // set the training total
        let localTrainingAmount = totalTraining
        setTotalTraining(localTrainingAmount += Training)

        // increment LVP
        let localLVP = totalVLP
        setTotalLVP(localLVP += LVP)

        // increment LWP
        let localLWP = totalLWP
        setTotalLWP(localLWP += LWP)

        // increment Jumper
        let localJumper = totalJumper
        setTotalJumper(localJumper += jumper)

        setThursdayRender(renderingthursday)
    }, [thursdaySorted])

    // friday change
    useEffect( () => {
        // local arrays for rendering
        let renderingfriday = []

        // local data
        let routeAmount = 0
        let miles = 0
        let LWP = 0
        let LVP = 0
        let Training = 0
        let supportLocal = 0
        let R2 = 0
        let R4 = 0
        let R6 = 0
        let jumper = 0

        fridaySorted.forEach( sortedDate => {
            // add the mileage
            miles += sortedDate.finish_mileage

            // // sweeper
            // if (sortedDate.route === 'Sweeper') {
            //     routeAmount += 1
            // }
            
            // add the overall route count if not training
            if (sortedDate.route !== "0" && sortedDate.route !== 'Classroom Training' && sortedDate.route !== "None" && sortedDate.route !== "Rescue Payment" && sortedDate.route !== 'Manager' && sortedDate.route !== 'Ride Along' && sortedDate.route !== 'Jumper') {

                if (sortedDate.route === 'Half Standard Van Route') {
                    routeAmount += 0.5

                } else {
                    // increment total routes
                    routeAmount += 1
                }

                // increment lvp for large van routes
                if (sortedDate.route === 'Full Large Van Route') {
                    LVP += 1
                }

            }

            // increment jumper
            if (sortedDate.route === 'Jumper') {
                jumper += 1
            }

            // add the training
            if (sortedDate.route === 'Classroom Training' || sortedDate.route === 'Ride Along') {
                Training++
            }

            // add the support, handle late wave payments
            if (sortedDate.supportArray) {
                sortedDate.supportArray.forEach( support => {
                    switch (support.name) {
                        case 'Late Wave Payment':
                            LWP += (parseInt(support.amount)/10)
                            break;
                        case 'R2':
                            R2 += 1;
                            break;
                        case 'R4':
                            R4 += 1;
                            break;
                        case 'R6':
                            R6 += 1;
                            break;
                        default:
                            supportLocal += parseFloat(support.amount)
                    }
                })
            }
        })
        renderingfriday.push(
            <Cells 
                routeAmount={routeAmount}
                miles={miles}
                LWP={LWP}
                LVP={LVP}
                Training={Training}
                support={supportLocal}
                R2={R2}
                R4={R4}
                R6={R6}
                jumper={jumper}
                day={'Friday'}
            />
        )

        // map the data into the excel
        let sundayH2oObj = []
        sundayH2oObj.push('H2OL', routeAmount, miles, LWP, LVP, Training, jumper, supportLocal, R2, R4, R6, 0, 0, 0)
        setFridayH2oArray(sundayH2oObj)
        
        // calculate miles
        let localTotalMiles = totalMiles
        setTotalMiles(localTotalMiles += miles)

        // calculate routes
        let localTotalRoutes = totalRoutes
        setTotalRoutes(localTotalRoutes += routeAmount)

        // handle R2
        let localR2 = totalR2
        setTotalR2(localR2 += R2)

        // handle R2
        let localR4 = totalR4
        setTotalR4(localR4 += R4)

        // handle R2
        let localR6 = totalR6
        setTotalR6(localR6 += R6)

        // support total
        let localTotalSupport = totalSupport
        setTotalSupport(localTotalSupport += supportLocal)

        // set the training total
        let localTrainingAmount = totalTraining
        setTotalTraining(localTrainingAmount += Training)

        // increment LVP
        let localLVP = totalVLP
        setTotalLVP(localLVP += LVP)

        // increment LWP
        let localLWP = totalLWP
        setTotalLWP(localLWP += LWP)

        // increment Jumper
        let localJumper = totalJumper
        setTotalJumper(localJumper += jumper)

        setFridayRender(renderingfriday)
    }, [fridaySorted])

    // saturday change
    useEffect( () => {
        // local arrays for rendering
        let renderingsaturday = []

        // local data
        let routeAmount = 0
        let miles = 0
        let LWP = 0
        let LVP = 0
        let Training = 0
        let supportLocal = 0
        let R2 = 0
        let R4 = 0
        let R6 = 0
        let jumper = 0
        
        saturdaySorted.forEach( sortedDate => {
            // add the mileage
            miles += sortedDate.finish_mileage
            

            // sweeper
            // if (sortedDate.route === 'Sweeper') {
            //     routeAmount += 1
            // }

            // add the overall route count if not training
            if (sortedDate.route !== "0" && sortedDate.route !== 'Classroom Training' && sortedDate.route !== "None" && sortedDate.route !== "Rescue Payment" && sortedDate.route !== 'Manager' && sortedDate.route !== 'Ride Along' && sortedDate.route !== 'Jumper') {

                if (sortedDate.route === 'Half Standard Van Route') {
                    routeAmount += 0.5

                } else {
                    // increment total routes
                    routeAmount += 1
                }

                // increment lvp for large van routes
                if (sortedDate.route === 'Full Large Van Route') {
                    LVP += 1
                }

            }

            // increment lvp for large van routes
            if (sortedDate.route === 'Jumper') {
                jumper += 1
            }

            // add the training
            if (sortedDate.route === 'Classroom Training' || sortedDate.route === 'Ride Along') {
                Training++
            }

            // add the support, handle late wave payments
            if (sortedDate.supportArray) {
                sortedDate.supportArray.forEach( support => {
                    switch (support.name) {
                        case 'Late Wave Payment':
                            LWP += (parseInt(support.amount)/10)
                            break;
                        case 'R2':
                            R2 += 1;
                            break;
                        case 'R4':
                            R4 += 1;
                            break;
                        case 'R6':
                            R6 += 1;
                            break;
                        default:
                            supportLocal += parseFloat(support.amount)
                    }
                })
            }
        })
        renderingsaturday.push(
            <Cells 
                routeAmount={routeAmount}
                miles={miles}
                LWP={LWP}
                LVP={LVP}
                Training={Training}
                support={supportLocal}
                R2={R2}
                R4={R4}
                R6={R6}
                jumper={jumper}
                day={'Saturday'}
            />
        )

        // map the data into the excel
        let sundayH2oObj = []
        sundayH2oObj.push('H2OL', routeAmount, miles, LWP, LVP, Training, jumper, supportLocal, R2, R4, R6, 0, 0, 0)
        setSaturdayH2oArray(sundayH2oObj)
        
        // calculate miles
        let localTotalMiles = totalMiles
        setTotalMiles(localTotalMiles += miles)

        // calculate routes
        let localTotalRoutes = totalRoutes
        setTotalRoutes(localTotalRoutes += routeAmount)

        // handle R2
        let localR2 = totalR2
        setTotalR2(localR2 += R2)

        // handle R2
        let localR4 = totalR4
        setTotalR4(localR4 += R4)

        // handle R2
        let localR6 = totalR6
        setTotalR6(localR6 += R6)

        // support total
        let localTotalSupport = totalSupport
        setTotalSupport(localTotalSupport += supportLocal)

        // set the training total
        let localTrainingAmount = totalTraining
        setTotalTraining(localTrainingAmount += Training)

        // increment LVP
        let localLVP = totalVLP
        setTotalLVP(localLVP += LVP)

        // increment LWP
        let localLWP = totalLWP
        setTotalLWP(localLWP += LWP)

        // increment Jumper
        let localJumper = totalJumper
        setTotalJumper(localJumper += jumper)

        setSaturdayRender(renderingsaturday)
    }, [saturdaySorted])

    // sunday change
    useEffect( () => {
        // local arrays for rendering
        let renderingsunday = []

        // local data
        let routeAmount = 0
        let miles = 0
        let LWP = 0
        let LVP = 0
        let Training = 0
        let supportLocal = 0
        let R2 = 0
        let R4 = 0
        let R6 = 0
        let jumper = 0

        sundaySorted.forEach( sortedDate => {
            if (sortedDate.route !== "0") {
                // add the mileage
                miles += sortedDate.finish_mileage
    
                // sweeper
                // if (sortedDate.route === 'Sweeper') {
                //     routeAmount++
                //     console.log('counting sweeper: ', routeAmount)
                // }
                
                // add the overall route count if not training
                if (sortedDate.route !== "0" && sortedDate.route !== 'Classroom Training' && sortedDate.route !== "None" && sortedDate.route !== "Rescue Payment" && sortedDate.route !== 'Manager' && sortedDate.route !== 'Ride Along' && sortedDate.route !== 'Jumper') {
    
                    if (sortedDate.route === 'Half Standard Van Route') {
                        routeAmount += 0.5
    
                    } else {
                        // increment total routes
                        routeAmount += 1
                    }
    
                    // increment lvp for large van routes
                    if (sortedDate.route === 'Full Large Van Route') {
                        LVP += 1
                    }
    
                }
                
                // increment lvp for large van routes
                if (sortedDate.route === 'Jumper') {
                    jumper += 1
                }

                // add the training
                if (sortedDate.route === 'Classroom Training' || sortedDate.route === 'Ride Along') {
                    Training++
                }
    
            // add the support, handle late wave payments
            if (sortedDate.supportArray) {
                sortedDate.supportArray.forEach( support => {
                    switch (support.name) {
                        case 'Late Wave Payment':
                            LWP += (parseInt(support.amount)/10)
                            break;
                        case 'R2':
                            R2 += 1;
                            break;
                        case 'R4':
                            R4 += 1;
                            break;
                        case 'R6':
                            R6 += 1;
                            break;
                        default:
                            supportLocal += parseFloat(support.amount)
                    }
                })
            }
            }
        })
        renderingsunday.push(
            <Cells 
                routeAmount={routeAmount}
                miles={miles}
                LWP={LWP}
                LVP={LVP}
                Training={Training}
                support={supportLocal}
                R2={R2}
                R4={R4}
                R6={R6}
                jumper={jumper}
                day={'Sunday'}
            />
        )

        // map the data into the excel
        let sundayH2oObj = []
        sundayH2oObj.push('H2OL', routeAmount, miles, LWP, LVP, Training, jumper, supportLocal, R2, R4, R6, 0, 0, 0)
        setSundayH2oArray(sundayH2oObj)

        // calculate miles
        let localTotalMiles = totalMiles
        setTotalMiles(localTotalMiles += miles)

        // calculate routes
        let localTotalRoutes = totalRoutes
        setTotalRoutes(localTotalRoutes += routeAmount)

        // handle R2
        let localR2 = totalR2
        setTotalR2(localR2 += R2)

        // handle R2
        let localR4 = totalR4
        setTotalR4(localR4 += R4)

        // handle R2
        let localR6 = totalR6
        setTotalR6(localR6 += R6)

        // support total
        let localTotalSupport = totalSupport
        setTotalSupport(localTotalSupport += supportLocal)

        // set the training total
        let localTrainingAmount = totalTraining
        setTotalTraining(localTrainingAmount += Training)

        // increment LVP
        let localLVP = totalVLP
        setTotalLVP(localLVP += LVP)

        // increment LWP
        let localLWP = totalLWP
        setTotalLWP(localLWP += LWP)

        // increment LWP
        let localJumper = totalJumper
        setTotalJumper(localJumper += jumper)

        setSundayRender(renderingsunday)
    }, [sundaySorted])

    // make the totals
    useEffect( () => {
        setTotalRender(            
            <BottomCells 
                routeAmount={totalRoutes}
                miles={totalMiles}
                LWP={totalLWP}
                LVP={totalVLP}
                Training={totalTraining}
                support={totalSupport}
                R2={totalR2 === 0 ? totalR2 : totalR2}
                R4={totalR4 === 0 ? totalR4 : totalR4}
                R6={totalR6 === 0 ? totalR6 : totalR6}
                jumper={totalJumper}
                day={'Total'}
            />
        )
    }, [totalLWP, totalMiles, totalRoutes, totalSupport, totalTraining, totalSupport, totalR2, totalR4, totalR6, sunday, totalJumper])

    // make the sums row
    useEffect( () => {
        setSumsRow(
            <SumsCells 
                routeAmount={amazonTotals[0] - totalRoutes}
                miles={amazonTotals[1] - totalMiles}
                LWP={amazonTotals[2] - totalLWP}
                LVP={amazonTotals[3] - totalVLP}
                Training={amazonTotals[4] - totalTraining}
                support={amazonTotals[5] - totalSupport}
                R2={amazonTotals[6]-totalR2}
                R4={amazonTotals[7]-totalR4}
                R6={amazonTotals[8]-totalR6}
                Missort4th={amazonTotals[9]}
                Missort6th={amazonTotals[10]}
                DPMOBONUS={amazonTotals[11]}
                Jumper={amazonTotals[12] - totalJumper}
                day={'Sums'}
            />
        )
    }, [totalRender, sunday, amazonTotals])

    // map the amazon data
    const handleSundayClick = (e) => {
        let localMatrix = [...totalAmazonRoutes]
        switch (e.target.id) {
            case 'routes' :
                localMatrix[0][0] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'miles' :
                localMatrix[0][1] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LWP' :
                localMatrix[0][2] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LVP' :
                localMatrix[0][3] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Training' :
                localMatrix[0][4] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Support' :
                localMatrix[0][5] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R2' :
                localMatrix[0][6] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R4' :
                localMatrix[0][7] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R6' :
                localMatrix[0][8] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 4th' :
                localMatrix[0][9] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 6th' :
                localMatrix[0][10] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'DPMO BONUS' :
                localMatrix[0][11] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Jumper' :
                localMatrix[0][12] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            default:
                break;    
        }
    }
    // map the amazon data
    const handleMondayClick = (e) => {
        let localMatrix = [...totalAmazonRoutes]
        switch (e.target.id) {
            case 'routes' :
                localMatrix[1][0] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'miles' :
                localMatrix[1][1] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LWP' :
                localMatrix[1][2] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LVP' :
                localMatrix[1][3] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Training' :
                localMatrix[1][4] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Support' :
                localMatrix[1][5] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R2' :
                localMatrix[1][6] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R4' :
                localMatrix[1][7] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R6' :
                localMatrix[1][8] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 4th' :
                localMatrix[1][9] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 6th' :
                localMatrix[1][10] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'DPMO BONUS' :
                localMatrix[1][11] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Jumper' :
                localMatrix[1][12] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            default:
                break;    
        }
    }
    // map the amazon data
    const handleTuesdayClick = (e) => {
        let localMatrix = [...totalAmazonRoutes]
        switch (e.target.id) {
            case 'routes' :
                localMatrix[2][0] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'miles' :
                localMatrix[2][1] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LWP' :
                localMatrix[2][2] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LVP' :
                localMatrix[2][3] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Training' :
                localMatrix[2][4] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Support' :
                localMatrix[2][5] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R2' :
                localMatrix[2][6] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R4' :
                localMatrix[2][7] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R6' :
                localMatrix[2][8] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 4th' :
                localMatrix[2][9] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 6th' :
                localMatrix[2][10] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'DPMO BONUS' :
                localMatrix[2][11] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Jumper' :
                localMatrix[2][12] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            default:
                break;    
        }
    }
    // map the amazon data
    const handleWednesdayClick = (e) => {
        let localMatrix = [...totalAmazonRoutes]
        switch (e.target.id) {
            case 'routes' :
                localMatrix[3][0] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'miles' :
                localMatrix[3][1] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LWP' :
                localMatrix[3][2] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LVP' :
                localMatrix[3][3] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Training' :
                localMatrix[3][4] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Support' :
                localMatrix[3][5] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R2' :
                localMatrix[3][6] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R4' :
                localMatrix[3][7] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R6' :
                localMatrix[3][8] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 4th' :
                localMatrix[3][9] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 6th' :
                localMatrix[3][10] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'DPMO BONUS' :
                localMatrix[3][11] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Jumper' :
                localMatrix[3][12] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            default:
                break;    
        }
    }

    // map the amazon data
    const handleThursdayClick = (e) => {
        let localMatrix = [...totalAmazonRoutes]
        switch (e.target.id) {
            case 'routes':
                localMatrix[4][0] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'miles':
                localMatrix[4][1] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LWP':
                localMatrix[4][2] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LVP':
                localMatrix[4][3] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Training':
                localMatrix[4][4] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Support':
                localMatrix[4][5] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R2' :
                localMatrix[4][6] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R4' :
                localMatrix[4][7] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R6' :
                localMatrix[4][8] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 4th' :
                localMatrix[4][9] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 6th' :
                localMatrix[4][10] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'DPMO BONUS' :
                localMatrix[4][11] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Jumper' :
                localMatrix[4][12] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            default:
                break;    
        }
    }

    // map the amazon data
    const handleFridayClick = (e) => {
        let localMatrix = [...totalAmazonRoutes]
        switch (e.target.id) {
            case 'routes' :
                localMatrix[5][0] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'miles' :
                localMatrix[5][1] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LWP' :
                localMatrix[5][2] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LVP' :
                localMatrix[5][3] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Training' :
                localMatrix[5][4] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Support' :
                localMatrix[5][5] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R2' :
                localMatrix[5][6] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R4' :
                localMatrix[5][7] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R6' :
                localMatrix[5][8] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 4th' :
                localMatrix[5][9] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 6th' :
                localMatrix[5][10] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'DPMO BONUS' :
                localMatrix[5][11] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Jumper' :
                localMatrix[5][12] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            default:
                break;    
        }
    }

    // map the amazon data
    const handleSaturdayClick = (e) => {
        let localMatrix = [...totalAmazonRoutes]
        switch (e.target.id) {
            case 'routes' :
                localMatrix[6][0] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'miles' :
                localMatrix[6][1] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LWP' :
                localMatrix[6][2] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'LVP' :
                localMatrix[6][3] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Training' :
                localMatrix[6][4] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Support' :
                localMatrix[6][5] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R2' :
                localMatrix[6][6] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R4' :
                localMatrix[6][7] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'R6' :
                localMatrix[6][8] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 4th' :
                localMatrix[6][9] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Missort 6th' :
                localMatrix[6][10] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'DPMO BONUS' :
                localMatrix[6][11] = e.target.value
                setTotalAmazonRoutes(localMatrix)
                break;
            case 'Jumper' :
            localMatrix[6][12] = e.target.value
            setTotalAmazonRoutes(localMatrix)
            break;
            default:
                break;    
        }
    }

    // map the totals after entry
    useEffect( () => {

        // reducer
        const summation = (accumulator, currentValue) => { 
            return Math.abs(accumulator) + Math.abs(currentValue)
        }

        // copy the data saince its a const
        let localAmazonTotals = [...amazonTotals]

        // matrix to work from
        let localMatrix = [ [], [], [], [], [], [], [], [], [], [], [], [], []]

        // populate the inverted matrix
        totalAmazonRoutes.forEach( (innerArray, innerArrayId) => {
            // looping through each array in the matrix
            innerArray.forEach( (arrayInput, arrayInputNumber) => {
                // for each number in the inner array, convert to float, push to correct index for summation
                localMatrix[arrayInputNumber].push(parseFloat(arrayInput))
            })
        })

        // sum the new arrays
        localMatrix.forEach( (innerArray, innerArrayId) => {
            localAmazonTotals[innerArrayId] = localMatrix[innerArrayId].reduce(summation, 0)
        })

        setAmazonTotals(localAmazonTotals)
    }, [totalAmazonRoutes, sunday])

    // handle setting the incoming data as function
    const mapAmazonDataFromBackend = () => {
        // reducer
        const summation = (accumulator, currentValue) => { 
            return Math.abs(accumulator) + Math.abs(currentValue)
        }

        // copy the data saince its a const
        let localAmazonTotals = [...amazonTotals]

        // matrix to work from
        let localMatrix = [ [], [], [], [], [], [], [], [], [], [], [], [], [] ]

        // populate the inverted matrix
        totalAmazonRoutes.forEach( (innerArray, innerArrayId) => {

            // looping through each array in the matrix
            innerArray.forEach( (arrayInput, arrayInputNumber) => {

                // for each number in the inner array, convert to float, push to correct index for summation
                localMatrix[arrayInputNumber].push(parseFloat(arrayInput))
            })
        })

        // sum the new arrays
        localMatrix.forEach( (innerArray, innerArrayId) => {
            localAmazonTotals[innerArrayId] = localMatrix[innerArrayId].reduce(summation, 0)
        })

        setAmazonTotals(localAmazonTotals)
    }

    // functions for handling date change
    const handleSelectSunday = (e, dateOne, dateTwo) => {
        setSunday(new Date(dateOne))
    }

    // get sundays
    const getSundaysTwo = () => {
        let sundays = []
        let currentDate = new Date()
        for (let i = -70; i < 40; i++) {
            let dateInner = new Date(currentDate.getFullYear(), currentDate.getMonth(), i)
            if (dateInner.getDay() === 0) {
                sundays.push(
                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectSunday(e, `${dateInner.toDateString()}`, `${dateInner.toDateString()}`)}><a href="#0" id="makeMeWhiteli">Week: {dateInner.getWeek()} | {dateInner.toLocaleDateString('en-GB')}</a></li>
                )
            }
        }
        return sundays
    }

    // make the list of sundays for the backend
    useEffect( () => {
        setOptionsThree(getSundaysTwo())
    }, [])

    // function for sending the amazon data to backend
    const handleSaveData = (e, dayName) => {
        setSavedScreen((
            <div>
                Saving
            </div>
        ))
        // initialize check for if dat exists
        let localId = 0

        // switch on the day being saved
        switch (dayName) {
            case 'Sunday':
                // check if the day exists
                amazonData.forEach( amazonObj => {
                    if (amazonObj.date === 'Sunday' && amazonObj.station === selectedCitySort) {

                        // save the id so local variable
                        localId = amazonObj.validationSheet_id
                    }
                })
                // post or put depending on if exists
                if (localId === 0) {
                    postData('https://backendpajamas.herokuapp.com/validationsheet/', {
                        date: 'Sunday',
                        manager_id: props.user_id,
                        week_number: new Date(sunday).getWeek(),
                        routes: typeof totalAmazonRoutes[0][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[0][0]) : 0,
                        miles:  typeof totalAmazonRoutes[0][1] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[0][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[0][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[0][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[0][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][4]) : 0,
                        support:  typeof totalAmazonRoutes[0][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][5]) : 0,
                        R2:  typeof totalAmazonRoutes[0][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][6]) : 0,
                        R4:  typeof totalAmazonRoutes[0][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][7] : 0,
                        R6:  typeof totalAmazonRoutes[0][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[0][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[0][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[0][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[0][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][12] : 0,
                        station: selectedCitySort
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                } else {
                    putData(`https://backendpajamas.herokuapp.com/validationsheet/${localId}/`, {
                        routes: typeof totalAmazonRoutes[0][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[0][0]) : 0,
                        miles:  typeof totalAmazonRoutes[0][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[0][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[0][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[0][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][4]) : 0,
                        support:  typeof totalAmazonRoutes[0][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][5]) : 0,
                        R2:  typeof totalAmazonRoutes[0][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[0][6]) : 0,
                        R4:  typeof totalAmazonRoutes[0][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][7] : 0,
                        R6:  typeof totalAmazonRoutes[0][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[0][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[0][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[0][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[0][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[0][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                }
            break;
            case 'Monday':
                amazonData.forEach( amazonObj => {
                    if (amazonObj.date === 'Monday' && amazonObj.station === selectedCitySort) {

                        // save the id so local variable
                        localId = amazonObj.validationSheet_id
                    }
                })
                if (localId === 0) {
                    postData('https://backendpajamas.herokuapp.com/validationsheet/', {
                        date: 'Monday',
                        manager_id: props.user_id,
                        week_number: new Date(sunday).getWeek(),
                        routes: typeof totalAmazonRoutes[1][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[1][0]) : 0,
                        miles:  typeof totalAmazonRoutes[1][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[1][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[1][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[1][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][4]) : 0,
                        support:  typeof totalAmazonRoutes[1][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][5]) : 0,
                        R2:  typeof totalAmazonRoutes[1][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][6]) : 0,
                        R4:  typeof totalAmazonRoutes[1][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][7] : 0,
                        R6:  typeof totalAmazonRoutes[1][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[1][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[1][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[1][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[1][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][12] : 0,
                        station: selectedCitySort
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                } else {
                    putData(`https://backendpajamas.herokuapp.com/validationsheet/${localId}/`, {
                        routes: typeof totalAmazonRoutes[1][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[1][0]) : 0,
                        miles:  typeof totalAmazonRoutes[1][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[1][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[1][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[1][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][4]) : 0,
                        support:  typeof totalAmazonRoutes[1][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][5]) : 0,
                        R2:  typeof totalAmazonRoutes[1][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[1][6]) : 0,
                        R4:  typeof totalAmazonRoutes[1][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][7] : 0,
                        R6:  typeof totalAmazonRoutes[1][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[1][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[1][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[1][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[1][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[1][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                }
            break;
            case 'Tuesday':
                amazonData.forEach( amazonObj => {
                    if (amazonObj.date === 'Tuesday' && amazonObj.station === selectedCitySort) {

                        // save the id so local variable
                        localId = amazonObj.validationSheet_id
                    }
                })
                if (localId === 0) {
                    postData('https://backendpajamas.herokuapp.com/validationsheet/', {
                        date: 'Tuesday',
                        week_number: new Date(sunday).getWeek(),
                        routes: typeof totalAmazonRoutes[2][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[2][0]) : 0,
                        miles:  typeof totalAmazonRoutes[2][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[2][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[2][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[2][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][4]) : 0,
                        support:  typeof totalAmazonRoutes[2][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][5]) : 0,
                        R2:  typeof totalAmazonRoutes[2][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][6]) : 0,
                        R4:  typeof totalAmazonRoutes[2][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][7] : 0,
                        R6:  typeof totalAmazonRoutes[2][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[2][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[2][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[2][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[2][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                } else {
                    putData(`https://backendpajamas.herokuapp.com/validationsheet/${localId}/`, {
                        routes: typeof totalAmazonRoutes[2][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[2][0]) : 0,
                        miles:  typeof totalAmazonRoutes[2][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[2][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[2][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[2][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][4]) : 0,
                        support:  typeof totalAmazonRoutes[2][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][5]) : 0,
                        R2:  typeof totalAmazonRoutes[2][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[2][6]) : 0,
                        R4:  typeof totalAmazonRoutes[2][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][7] : 0,
                        R6:  typeof totalAmazonRoutes[2][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[2][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[2][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[2][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[2][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[2][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                }
            break;
            case 'Wednesday':
                amazonData.forEach( amazonObj => {
                    if (amazonObj.date === 'Wednesday' && amazonObj.station === selectedCitySort) {

                        // save the id so local variable
                        localId = amazonObj.validationSheet_id
                    }
                })
                if (localId === 0) {
                    postData('https://backendpajamas.herokuapp.com/validationsheet/', {
                        date: 'Wednesday',
                        week_number: new Date(sunday).getWeek(),
                        routes: typeof totalAmazonRoutes[3][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[3][0]) : 0,
                        miles:  typeof totalAmazonRoutes[3][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[3][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[3][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[3][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][4]) : 0,
                        support:  typeof totalAmazonRoutes[3][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][5]) : 0,
                        R2:  typeof totalAmazonRoutes[3][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][6]) : 0,
                        R4:  typeof totalAmazonRoutes[3][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][7] : 0,
                        R6:  typeof totalAmazonRoutes[3][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[3][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[3][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[3][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[3][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                } else {
                    putData(`https://backendpajamas.herokuapp.com/validationsheet/${localId}/`, {
                        routes: typeof totalAmazonRoutes[3][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[3][0]) : 0,
                        miles:  typeof totalAmazonRoutes[3][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[3][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[3][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[3][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][4]) : 0,
                        support:  typeof totalAmazonRoutes[3][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][5]) : 0,
                        R2:  typeof totalAmazonRoutes[3][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[3][6]) : 0,
                        R4:  typeof totalAmazonRoutes[3][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][7] : 0,
                        R6:  typeof totalAmazonRoutes[3][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[3][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[3][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[3][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[3][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[3][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                }
            break;
            case 'Thursday':
                amazonData.forEach( amazonObj => {
                    if (amazonObj.date === 'Thursday' && amazonObj.station === selectedCitySort) {

                        // save the id so local variable
                        localId = amazonObj.validationSheet_id
                    }
                })
                if (localId === 0) {
                    postData('https://backendpajamas.herokuapp.com/validationsheet/', {
                        date: 'Thursday',
                        week_number: new Date(sunday).getWeek(),
                        routes: typeof totalAmazonRoutes[4][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[4][0]) : 0,
                        miles:  typeof totalAmazonRoutes[4][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[4][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[4][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[4][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][4]) : 0,
                        support:  typeof totalAmazonRoutes[4][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][5]) : 0,
                        R2:  typeof totalAmazonRoutes[4][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][6]) : 0,
                        R4:  typeof totalAmazonRoutes[4][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][7] : 0,
                        R6:  typeof totalAmazonRoutes[4][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[4][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[4][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[4][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[4][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                } else {
                    putData(`https://backendpajamas.herokuapp.com/validationsheet/${localId}/`, {
                        routes: typeof totalAmazonRoutes[4][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[4][0]) : 0,
                        miles:  typeof totalAmazonRoutes[4][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[4][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[4][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[4][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][4]) : 0,
                        support:  typeof totalAmazonRoutes[4][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][5]) : 0,
                        R2:  typeof totalAmazonRoutes[4][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[4][6]) : 0,
                        R4:  typeof totalAmazonRoutes[4][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][7] : 0,
                        R6:  typeof totalAmazonRoutes[4][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[4][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[4][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[4][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[4][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[4][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                }
            break;
            case 'Friday':
                amazonData.forEach( amazonObj => {
                    if (amazonObj.date === 'Friday' && amazonObj.station === selectedCitySort) {

                        // save the id so local variable
                        localId = amazonObj.validationSheet_id
                    }
                })
                if (localId === 0) {
                    postData('https://backendpajamas.herokuapp.com/validationsheet/', {
                        date: 'Friday',
                        week_number: new Date(sunday).getWeek(),
                        routes: typeof totalAmazonRoutes[5][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[5][0]) : 0,
                        miles:  typeof totalAmazonRoutes[5][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[5][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[5][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[5][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][4]) : 0,
                        support:  typeof totalAmazonRoutes[5][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][5]) : 0,
                        R2:  typeof totalAmazonRoutes[5][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][6]) : 0,
                        R4:  typeof totalAmazonRoutes[5][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][7] : 0,
                        R6:  typeof totalAmazonRoutes[5][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[5][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[5][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[5][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[5][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                } else {
                    putData(`https://backendpajamas.herokuapp.com/validationsheet/${localId}/`, {
                        routes: typeof totalAmazonRoutes[5][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[5][0]) : 0,
                        miles:  typeof totalAmazonRoutes[5][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[5][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[5][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[5][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][4]) : 0,
                        support:  typeof totalAmazonRoutes[5][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][5]) : 0,
                        R2:  typeof totalAmazonRoutes[5][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[5][6]) : 0,
                        R4:  typeof totalAmazonRoutes[5][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][7] : 0,
                        R6:  typeof totalAmazonRoutes[5][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[5][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[5][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[5][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[5][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[5][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                }
            break;
            case 'Saturday':
                amazonData.forEach( amazonObj => {
                    if (amazonObj.date === 'Saturday' && amazonObj.station === selectedCitySort) {

                        // save the id so local variable
                        localId = amazonObj.validationSheet_id
                    }
                })
                if (localId === 0) {
                    postData('https://backendpajamas.herokuapp.com/validationsheet/', {
                        date: 'Saturday',
                        week_number: new Date(sunday).getWeek(),
                        routes: typeof totalAmazonRoutes[6][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[6][0]) : 0,
                        miles:  typeof totalAmazonRoutes[6][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[6][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[6][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[6][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][4]) : 0,
                        support:  typeof totalAmazonRoutes[6][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][5]) : 0,
                        R2:  typeof totalAmazonRoutes[6][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][6]) : 0,
                        R4:  typeof totalAmazonRoutes[6][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][7] : 0,
                        R6:  typeof totalAmazonRoutes[6][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[6][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[6][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[6][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[6][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                } else {
                    putData(`https://backendpajamas.herokuapp.com/validationsheet/${localId}/`, {
                        routes: typeof totalAmazonRoutes[6][0] === typeof 'flabbergasted'  || typeof 2 ? parseInt(totalAmazonRoutes[6][0]) : 0,
                        miles:  typeof totalAmazonRoutes[6][1] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][1]) : 0,
                        totalLwp:  typeof totalAmazonRoutes[6][2] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][2]) : 0,
                        totalLVP:  typeof totalAmazonRoutes[6][3] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][3]) : 0,
                        totalTraining:  typeof totalAmazonRoutes[6][4] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][4]) : 0,
                        support:  typeof totalAmazonRoutes[6][5] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][5]) : 0,
                        R2:  typeof totalAmazonRoutes[6][6] === typeof 'flabbergasted' || typeof 2 ? parseInt(totalAmazonRoutes[6][6]) : 0,
                        R4:  typeof totalAmazonRoutes[6][7] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][7] : 0,
                        R6:  typeof totalAmazonRoutes[6][8] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][8] : 0,
                        Missortfourth:  typeof totalAmazonRoutes[6][9] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][9] : 0,
                        Missortsixth:  typeof totalAmazonRoutes[6][10] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][10] : 0,
                        DpmoBonus:  typeof totalAmazonRoutes[6][11] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][11] : 0,
                        Jumper:  typeof totalAmazonRoutes[6][12] === typeof 'flabbergasted' || typeof 2 ? totalAmazonRoutes[6][12] : 0,
                        station: selectedCitySort,
                        manager_id: props.user_id,
                    }).then( response => {
                        if (response) {
                            setSavedScreen((
                                <div>
                                    Saved
                                </div>
                            ))
                            setTimeout( () => {
                                setSavedScreen(null)
                            }, [2000])
                        }
                    })
                }
            break;
            default:
                break;
        }
    }

    useEffect( () => {
        if (props.superUser) {
            setList([
                'DBS2',
                'DXP1',
                'DSN1',
                'DCF1',
                'DEX2'
            ])
        } else {
            setList(props.station)
        }
    }, [props])


    // change the city
    const onSelectCity = (e) => {
        setSelectedCitySort(e.value)
    }

    // handle making the final sums page
    useEffect( () => {
        // let h20Expense = totalRoutes*126.80 + totalMiles*.165 + totalLWP*10 + totalVLP*20 + totalTraining*99 + totalSupport
        // let amazonProfit = amazonTotals[0]*182.1 + amazonTotals[1] + amazonTotals[2]*10 + amazonTotals[3]*19.30 + amazonTotals[4]*119.5 + amazonTotals[5] + amazonTotals[6] *44.52 + amazonTotals[7]*82.76 + amazonTotals[8]*122.04 + amazonTotals[9]*90.36 + amazonTotals[10]*135.03
            // xcel csv
        function excel() {
            async function makeXcelData ()  {
                let localArray = []
                // labels
                let localDataLabels = [selectedCitySort, 'DSP', 'Routes', 'Miles', 'LWP', 'LVP', 'Jumper', 'Training', 'Support', 'R2', 'R4', 'R6', 'Missort 4hr', 'Missort 6hr', 'AMZL Late Cancel']
                localArray.unshift(localDataLabels)
    
                // handle sunday
                    // H20
                    let sundayH20Array = ['Sunday', ...sundayH2oArray]

                    // switch the 6 nad 7 index
                    let var6 = sundayH20Array[7]
                    sundayH20Array[7] = sundayH20Array[6] 
                    sundayH20Array[6] = var6

                    localArray.push(sundayH20Array)
    
                    // Amazon
                    let localSunday = [...totalAmazonRoutes[0]]
    
                    // save the value to put earlier in the array
                    let jumperValue = localSunday[localSunday.length-1]
    
                    // reduce the length of the array by one
                    localSunday.pop()
    
                    // // add the value back in
                    localSunday.splice(4, 0, jumperValue)
    
                    let sundayAmznArray = ['Sunday', 'AMZN', ...localSunday]
                    localArray.push(sundayAmznArray)
    
                // handle monday
                    // H20
                    let mondayH20Array = ['Monday', ...mondayH2oArray]

                    // switch the 6 nad 7 index
                    let mvar6 = mondayH20Array[7]
                    mondayH20Array[7] = mondayH20Array[6] 
                    mondayH20Array[6] = mvar6

                    localArray.push(mondayH20Array)
    
                    // Amazon
                    localSunday = [...totalAmazonRoutes[1]]
    
                    // save the value to put earlier in the array
                    jumperValue = localSunday[localSunday.length-1]
    
                    // reduce the length of the array by one
                    localSunday.pop()
    
                    // // add the value back in
                    localSunday.splice(4, 0, jumperValue)
    
                    sundayAmznArray = ['Monday', 'AMZN', ...localSunday]
                    localArray.push(sundayAmznArray)
    
                // handle tuesday
                    // H20
                    let tuesdayH20Array = ['Tuesday', ...tuesdayH2oArray]

                    // switch the 6 nad 7 index
                    let tvar6 = tuesdayH20Array[7]
                    tuesdayH20Array[7] = tuesdayH20Array[6] 
                    tuesdayH20Array[6] = tvar6

                    localArray.push(tuesdayH20Array)
    
                    // Amazon
                    localSunday = [...totalAmazonRoutes[2]]
    
                    // save the value to put earlier in the array
                    jumperValue = localSunday[localSunday.length-1]
    
                    // reduce the length of the array by one
                    localSunday.pop()
    
                    // // add the value back in
                    localSunday.splice(4, 0, jumperValue)
    
                    sundayAmznArray = ['Tuesday', 'AMZN', ...localSunday]
                    localArray.push(sundayAmznArray)
    
                // handle wednesday
                    // H20
                    let wednesdayH20Array = ['Wednesday', ...wednesdayH2oArray]

                    // switch the 6 nad 7 index
                    let wvar6 = wednesdayH20Array[7]
                    wednesdayH20Array[7] = wednesdayH20Array[6] 
                    wednesdayH20Array[6] = wvar6

                    localArray.push(wednesdayH20Array)
    
                    // Amazon
                    localSunday = [...totalAmazonRoutes[3]]
    
                    // save the value to put earlier in the array
                    jumperValue = localSunday[localSunday.length-1]
    
                    // reduce the length of the array by one
                    localSunday.pop()
    
                    // // add the value back in
                    localSunday.splice(4, 0, jumperValue)
    
                    sundayAmznArray = ['Wednesday', 'AMZN', ...localSunday]
                    localArray.push(sundayAmznArray)
    
                // handle thursday
                    // H20
                    let thursdayH20Array = ['Thursday', ...thursdayH2oArray]

                    // switch the 6 nad 7 index
                    let thvar6 = thursdayH20Array[7]
                    thursdayH20Array[7] = thursdayH20Array[6] 
                    thursdayH20Array[6] = thvar6

                    localArray.push(thursdayH20Array)
    
                    // Amazon
                    localSunday = [...totalAmazonRoutes[4]]
    
                    // save the value to put earlier in the array
                    jumperValue = localSunday[localSunday.length-1]
    
                    // reduce the length of the array by one
                    localSunday.pop()
    
                    // // add the value back in
                    localSunday.splice(4, 0, jumperValue)
    
                    sundayAmznArray = ['Thursday', 'AMZN', ...localSunday]
                    localArray.push(sundayAmznArray)
    
                // handle friday
                    // H20
                    let fridayH20Array = ['Friday', ...fridayH2oArray]

                    // switch the 6 nad 7 index
                    let fvar6 = fridayH20Array[7]
                    fridayH20Array[7] = fridayH20Array[6] 
                    fridayH20Array[6] = fvar6

                    localArray.push(fridayH20Array)
    
                    // Amazon
                    localSunday = [...totalAmazonRoutes[5]]
    
                    // save the value to put earlier in the array
                    jumperValue = localSunday[localSunday.length-1]
    
                    // reduce the length of the array by one
                    localSunday.pop()
    
                    // // add the value back in
                    localSunday.splice(4, 0, jumperValue)
    
                    sundayAmznArray = ['Friday', 'AMZN', ...localSunday]
                    localArray.push(sundayAmznArray)
    
                // handle Saturday
                    // H20
                    let saturdayH20Array = ['Saturday', ...saturdayH2oArray]

                    // switch the 6 nad 7 index
                    let svar6 = saturdayH20Array[7]
                    saturdayH20Array[7] = saturdayH20Array[6] 
                    saturdayH20Array[6] = svar6

                    localArray.push(saturdayH20Array)
    
                    // Amazon
                    localSunday = [...totalAmazonRoutes[6]]
    
                    // save the value to put earlier in the array
                    jumperValue = localSunday[localSunday.length-1]
    
                    // reduce the length of the array by one
                    localSunday.pop()
    
                    // // add the value back in
                    localSunday.splice(4, 0, jumperValue)
    
                    sundayAmznArray = ['Saturday', 'AMZN', ...localSunday]
                    localArray.push(sundayAmznArray)
    
                // handle totals    
                    // h20 totals
                    let h20Totals = ['Total', 'H2OL', totalRoutes, totalMiles, totalLWP, totalVLP, totalJumper, totalTraining, totalSupport, totalR2, totalR4, totalR6, 0, 0, 0]
                    localArray.push(h20Totals)
    
                    // amazon totals
                    let amazonTotalsArray = ['Total', 'AMZN', amazonTotals[0], amazonTotals[1], amazonTotals[2], amazonTotals[3], amazonTotals[12], amazonTotals[4], amazonTotals[5], amazonTotals[6], amazonTotals[7], amazonTotals[8], amazonTotals[9], amazonTotals[10], amazonTotals[11]]
                    localArray.push(amazonTotalsArray)
    
                // handle sums    
                let routeAmount = typeof amazonTotals[0] === typeof 2 ? amazonTotals[0] - totalRoutes: totalRoutes
                let miles = typeof amazonTotals[1] === typeof 2 ? amazonTotals[1] - totalMiles: totalMiles
                let LWP = typeof amazonTotals[2] === typeof 2 ? amazonTotals[2] - totalLWP: totalLWP
                let LVP = typeof amazonTotals[3] === typeof 2 ? amazonTotals[3] - totalVLP: totalVLP
                let Training = typeof amazonTotals[4] === typeof 2 ? amazonTotals[4] - totalTraining: totalTraining
                let support = typeof amazonTotals[5] === typeof 2 ? amazonTotals[5] - totalSupport: totalSupport
                let R2 = totalR2 === 0 ? amazonTotals[6] : amazonTotals[6]-totalR2
                let R4 = totalR2 === 0 ? amazonTotals[7] : amazonTotals[7]-totalR4
                let R6 = totalR2 === 0 ? amazonTotals[8] : amazonTotals[8]-totalR6
                let Missort4th = amazonTotals[9]
                let Missort6th = amazonTotals[10]
                let DPMOBONUS = amazonTotals[11]
                let jumper = typeof amazonTotals[12] === typeof 2 ? amazonTotals[12] - totalJumper: totalJumper
    
                let finalTotals = ['Sums', 'H2OL', routeAmount, miles, LWP, LVP, jumper, Training, support, R2, R4, R6, Missort4th, Missort6th, DPMOBONUS]
                localArray.push(finalTotals)
    
                console.log("done")
                // handle final sums
                    // H20L Expense
                    // localArray.push(['H2OL EXPENSE', parseFloat(h20Expense).toFixed(2)])   
                    
                    // // AMZON PROFIT
                    // localArray.push(['AMZL PROFIT', parseFloat(amazonProfit).toFixed(2)])
    
                    // // PROFIT
                    // localArray.push(['PROFIT', parseFloat(amazonProfit-h20Expense).toFixed(2)])
    
                    // // MANAGER EXPENSE
                    // localArray.push(['OSM EXPENCE', parseFloat(managerRoutes*120).toFixed(2)])
    
                    // // GRAND PROFIT
                    // localArray.push(['GRAND PROFIT', parseFloat(amazonProfit-h20Expense-parseFloat(managerRoutes*120)).toFixed(2)])
    
                setXcelData(localArray)
            }
            makeXcelData().then( response => {
                setCsvRenderBool(true)
                setTimeout( () => {
                    setCsvRenderBool(false)
                }, 1500)
            })
        }
        let throttled = _.debounce(excel, 1500)

        throttled()
    }, [sumsRow])

    // make a statement
    useEffect( () => {
        if (csvRenderBool) {
            setCsvRenderStatement(
                <div>
                    <h3>Changing Csv</h3>
                </div>
            )
            setTimeout( () => {
                setCsvRenderStatement(
                    <div>
                        <h3>Csv Ready</h3>
                    </div>
                )
            }, 1500)
            setTimeout( () => {
                setCsvRenderStatement(null)
            }, 3000)
        }
    }, [csvRenderBool])

    // make entry possible
    if (props.superUser) {
        return (
            <>
                {messageScreen}
                <div className='home_content'>
                    <NavigationBar title={`Validation Report ${titleText}`} superUser={props.superUser ? true : false} email={props.user_email}/>
                    <div className='clockContainer'>
                        <RentalClock 
                            currentDate={currentDate}
                            selectedDate={sunday}
                            changedSelection={changedSelection}
                        />
                    </div>
                    <div className='statistics_container'>
                            {csvRenderStatement}
                        <div className='topDateChange'>
                            <nav className="menu">
                                <ol>
                                    <li className="menu-item" id="makeMeWhite"><a href="#0" id="makeMeWhite">Week: {sunday.getWeek()} | {sunday.toLocaleDateString('en-GB')}</a>
                                        <ol className="sub-menu" id='limitHeight'>
                                            {optionsThree}
                                        </ol>
                                    </li>
                                </ol>
                            </nav>
                            {savedScreen}
                        </div>
                        <div className={lockDiv}>
                        </div>
                            <table>
                                <tr id='makeAvailable'>
                                    <td className='littleRow' id='stationLabel'>
                                        <Dropdown 
                                            options={list} 
                                            onChange={onSelectCity} 
                                            value={selectedCitySort} 
                                            placeholder="Select an option" 
                                        />
                                    </td>
                                    <tr>
                                        <td className='littleRow'>DSP</td>
                                        <td className='littleRow'>Routes</td>
                                        <td className='littleRow'>Miles</td>
                                        <td className='littleRow'>LWP</td>
                                        <td className='littleRow'>LVP</td>
                                        <td className='littleRow'>Jumper</td>
                                        <td className='littleRow'>Training</td>
                                        <td className='littleRow'>Support</td>
                                        <td className='littleRow'>R2</td>
                                        <td className='littleRow'>R4</td>
                                        <td className='littleRow'>R6</td>
                                        <td className='littleRow'>Missort 4hr</td>
                                        <td className='littleRow'>Missort 6hr</td>
                                        <td className='littleRow'>AMZL Late Cancel</td>
                                        <td className='littleRowSave'></td>
                                    </tr>
                                </tr>
                                    <tr>
                                        {sundayRender}
                                        <tr onChange={handleSundayClick}>
                                            <td className='littleRowAmazon'>AMZL</td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][0]} id='routes'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][1]} id='miles'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[0][2]} id='LWP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[0][3]} id='LVP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[0][12]} id='Jumper'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][4]} id='Training'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][5]} id='Support'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][6]} id='R2'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][7]} id='R4'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][8]} id='R6'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][9]} id='Missort 4th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][10]} id='Missort 6th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[0][11]} id='DPMO BONUS'/>
                                            </td>
                                            <td className='littleRowAmazonSave'>
                                                <button onClick={(e, dayName) => handleSaveData(e, 'Sunday')}>Save</button>
                                            </td>
                                        </tr>
                                    </tr>
                                    <tr>
                                        {mondayRender}
                                        <tr onChange={handleMondayClick}>
                                            <td className='littleRowAmazon'>AMZL</td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][0]} id='routes'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][1]} id='miles'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[1][2]} id='LWP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[1][3]} id='LVP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[1][12]} id='Jumper'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][4]} id='Training'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][5]} id='Support'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][6]} id='R2'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][7]} id='R4'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][8]} id='R6'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][9]} id='Missort 4th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][10]} id='Missort 6th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[1][11]} id='DPMO BONUS'/>
                                            </td>
                                            <td className='littleRowAmazonSave'>
                                                <button onClick={(e, dayName) => handleSaveData(e, 'Monday')}>Save</button>
                                            </td>
                                        </tr>
                                    </tr>
                                    <tr>
                                        {tuesdayRender}
                                        <tr onChange={handleTuesdayClick}>
                                            <td className='littleRowAmazon'>AMZL</td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][0]} id='routes'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][1]} id='miles'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[2][2]} id='LWP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[2][3]} id='LVP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[2][12]} id='Jumper'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][4]} id='Training'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][5]} id='Support'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][6]} id='R2'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][7]} id='R4'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][8]} id='R6'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][9]} id='Missort 4th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][10]} id='Missort 6th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[2][11]} id='DPMO BONUS'/>
                                            </td>
                                            <td className='littleRowAmazonSave'>
                                            <button onClick={(e, dayName) => handleSaveData(e, 'Tuesday')}>Save</button>
                                            </td>
                                        </tr>
                                    </tr>
                                    <tr>
                                        {wednesdayRender}
                                        <tr onChange={handleWednesdayClick}>
                                            <td className='littleRowAmazon'>AMZL</td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][0]} id='routes'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][1]} id='miles'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[3][2]} id='LWP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[3][3]} id='LVP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[3][12]} id='Jumper'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][4]} id='Training'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][5]} id='Support'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][6]} id='R2'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][7]} id='R4'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][8]} id='R6'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][9]} id='Missort 4th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][10]} id='Missort 6th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[3][11]} id='DPMO BONUS'/>
                                            </td>
                                            <td className='littleRowAmazonSave'>
                                            <button onClick={(e, dayName) => handleSaveData(e, 'Wednesday')}>Save</button>
                                            </td>
                                        </tr>
                                    </tr>
                                    <tr>
                                        {thursdayRender}
                                        <tr onChange={handleThursdayClick}>
                                            <td className='littleRowAmazon'>AMZL</td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][0]} id='routes'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][1]} id='miles'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[4][2]} id='LWP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[4][3]} id='LVP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[4][12]} id='Jumper'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][4]} id='Training'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][5]} id='Support'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][6]} id='R2'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][7]} id='R4'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][8]} id='R6'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][9]} id='Missort 4th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][10]} id='Missort 6th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[4][11]} id='DPMO BONUS'/>
                                            </td>
                                            <td className='littleRowAmazonSave'>
                                            <button onClick={(e, dayName) => handleSaveData(e, 'Thursday')}>Save</button>
                                            </td>
                                        </tr>
                                    </tr>
                                    <tr>
                                        {fridayRender}
                                        <tr onChange={handleFridayClick}>
                                            <td className='littleRowAmazon'>AMZL</td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][0]} id='routes'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][1]} id='miles'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[5][2]} id='LWP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[5][3]} id='LVP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[5][12]} id='Jumper'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][4]} id='Training'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][5]} id='Support'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][6]} id='R2'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][7]} id='R4'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][8]} id='R6'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][9]} id='Missort 4th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][10]} id='Missort 6th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[5][11]} id='DPMO BONUS'/>
                                            </td>
                                            <td className='littleRowAmazonSave'>
                                            <button onClick={(e, dayName) => handleSaveData(e, 'Friday')}>Save</button>
                                            </td>
                                        </tr>
                                    </tr>
                                    <tr>
                                        {saturdayRender}
                                        <tr onChange={handleSaturdayClick}>
                                            <td className='littleRowAmazon'>AMZL</td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][0]} id='routes'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][1]} id='miles'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[6][2]} id='LWP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[6][3]} id='LVP'/>
                                            </td>
                                            <td className='littleRowAmazon' >
                                                <input type="text" value={totalAmazonRoutes[6][12]} id='Jumper'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][4]} id='Training'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][5]} id='Support'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][6]} id='R2'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][7]} id='R4'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][8]} id='R6'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][9]} id='Missort 4th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][10]} id='Missort 6th'/>
                                            </td>
                                            <td className='littleRowAmazon'>
                                                <input type="text" value={totalAmazonRoutes[6][11]} id='DPMO BONUS'/>
                                            </td>
                                            <td className='littleRowAmazonSave'>
                                            <button onClick={(e, dayName) => handleSaveData(e, 'Saturday')}>Save</button>
                                            </td>
                                        </tr>
                                    </tr>
                                    <tr>
                                        {totalRender}
                                        <tr>
                                            <td className='littleRowAmazonTotal'>AMZL</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[0]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[1]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[2]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[3]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[12]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[4]}</td>
                                            <td className='littleRowAmazonTotal'>{parseFloat(amazonTotals[5]).toFixed(2)}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[6]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[7]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[8]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[9]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[10]}</td>
                                            <td className='littleRowAmazonTotal'>{amazonTotals[11]}</td>
                                        </tr>
                                    </tr>
                                    <br />
                                    <tr>
                                        {sumsRow}
                                        <tr>
                                        </tr>
                                    </tr>
                            </table>
                        <div className='bottomSection'>
                            {/* <table>
                                {finalSums}
                            </table> */}
                            { props.user_email !== "invoices@h2ologistics.co.uk" ? <div className={textState} onClick={handleChangeBoxSize}><h3>Messages</h3><div className='messageBoxTextContainer'>{messages}</div><button onClick={handleToggleMessageScreen}>Submit Message</button></div> : null}
                        </div>
                        <div className='makeTheseLignUp'>
                            <CSVLink data={xcelData} className='compliance_add_driver_button_submit' id='summary_button'>
                                <span className='span_in_complaince_button'>csv</span> 
                            </CSVLink>   
                            <div className='compliance_add_driver_button_submit' id='summary_button' onClick={handleLock}>
                                <span className='span_in_complaince_button'>{lockText}</span> 
                            </div>
                        </div>
                    <br/>
                    </div>
                </div>
            </>
        )
    } else {
        return (
            <>
                {messageScreen}
                <div className='home_content'>
                    <NavigationBar title={`Validation Report ${titleText}`} superUser={props.superUser ? true : false} email={props.user_email}/>
                    <div className='clockContainer'>
                        <RentalClock 
                            currentDate={currentDate}
                            selectedDate={sunday}
                            changedSelection={changedSelection}
                        />
                    </div>
                    <div className='statistics_container'>
                        <div className='topDateChange'>
                            <nav className="menu">
                                <ol>
                                    <li className="menu-item" id="makeMeWhite" ><a href="#0" id="makeMeWhite">Week: {sunday.getWeek()} | {sunday.toLocaleDateString('en-GB')}</a>
                                        <ol className="sub-menu" id='limitHeight'>
                                            {optionsThree}
                                        </ol>
                                    </li>
                                </ol>
                            </nav>
                            {savedScreen}
                        </div>
                        <div className={lockDiv}>
                        </div>
                        <table>
                            <tr id='makeAvailable'>
                                <td className='littleRow' id='stationLabel'>
                                    <Dropdown 
                                        options={list} 
                                        onChange={onSelectCity} 
                                        value={selectedCitySort} 
                                        placeholder="Select an option" 
                                    />
                                </td>
                                <tr>
                                    <td className='littleRow'>DSP</td>
                                    <td className='littleRow'>Routes</td>
                                    <td className='littleRow'>Miles</td>
                                    <td className='littleRow'>LWP</td>
                                    <td className='littleRow'>LVP</td>
                                    <td className='littleRow'>Jumper</td>
                                    <td className='littleRow'>Training</td>
                                    <td className='littleRow'>Support</td>
                                    <td className='littleRow'>R2</td>
                                    <td className='littleRow'>R4</td>
                                    <td className='littleRow'>R6</td>
                                    <td className='littleRow'>Missort 4th</td>
                                    <td className='littleRow'>Missort 6th</td>
                                    <td className='littleRow'>AMZL Late Cancel</td>
                                    <td className='littleRowSave'></td>
                                </tr>
                            </tr>
                            <tr>
                                {/* {sundayRender} */}
                                <td className='bigRow'>Sunday</td>
                                    <tr>
                                    </tr>
                                <tr onChange={handleSundayClick}>
                                    <td className='littleRowAmazon'>AMZL</td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][0]} id='routes'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][1]} id='miles'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[0][2]} id='LWP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[0][3]} id='LVP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[0][12]} id='Jumper'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][4]} id='Training'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][5]} id='Support'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][6]} id='R2'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][7]} id='R4'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][8]} id='R6'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][9]} id='Missort 4th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][10]} id='Missort 6th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[0][11]} id='DPMO BONUS'/>
                                    </td>
                                    <td className='littleRowAmazonSave'>
                                        <button onClick={(e, dayName) => handleSaveData(e, 'Sunday')}>Save</button>
                                    </td>
                                </tr>
                            </tr>
                            <tr>
                                {/* {mondayRender} */}
                                <td className='bigRow'>Monday</td>
                                    <tr>
                                    </tr>
                                <tr onChange={handleMondayClick}>
                                    <td className='littleRowAmazon'>AMZL</td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][0]} id='routes'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][1]} id='miles'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[1][2]} id='LWP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[1][3]} id='LVP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[1][12]} id='Jumper'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][4]} id='Training'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][5]} id='Support'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][6]} id='R2'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][7]} id='R4'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][8]} id='R6'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][9]} id='Missort 4th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][10]} id='Missort 6th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[1][11]} id='DPMO BONUS'/>
                                    </td>
                                    <td className='littleRowAmazonSave'>
                                        <button onClick={(e, dayName) => handleSaveData(e, 'Monday')}>Save</button>
                                    </td>
                                </tr>
                            </tr>
                            <tr>
                                {/* {tuesdayRender} */}
                                <td className='bigRow'>Tuesday</td>
                                    <tr>
                                    </tr>
                                <tr onChange={handleTuesdayClick}>
                                    <td className='littleRowAmazon'>AMZL</td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][0]} id='routes'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][1]} id='miles'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[2][2]} id='LWP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[2][3]} id='LVP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[2][12]} id='Jumper'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][4]} id='Training'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][5]} id='Support'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][6]} id='R2'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][7]} id='R4'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][8]} id='R6'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][9]} id='Missort 4th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][10]} id='Missort 6th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[2][11]} id='DPMO BONUS'/>
                                    </td>
                                    <td className='littleRowAmazonSave'>
                                    <button onClick={(e, dayName) => handleSaveData(e, 'Tuesday')}>Save</button>
                                    </td>
                                </tr>
                            </tr>
                            <tr>
                                {/* {wednesdayRender} */}
                                <td className='bigRow'>Wednesday</td>
                                    <tr>
                                    </tr>
                                <tr onChange={handleWednesdayClick}>
                                    <td className='littleRowAmazon'>AMZL</td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][0]} id='routes'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][1]} id='miles'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[3][2]} id='LWP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[3][3]} id='LVP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[3][12]} id='Jumper'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][4]} id='Training'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][5]} id='Support'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][6]} id='R2'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][7]} id='R4'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][8]} id='R6'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][9]} id='Missort 4th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][10]} id='Missort 6th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[3][11]} id='DPMO BONUS'/>
                                    </td>
                                    <td className='littleRowAmazonSave'>
                                    <button onClick={(e, dayName) => handleSaveData(e, 'Wednesday')}>Save</button>
                                    </td>
                                </tr>
                            </tr>
                            <tr>
                                {/* {thursdayRender} */}
                                <td className='bigRow'>Thursday</td>
                                    <tr>
                                    </tr>
                                <tr onChange={handleThursdayClick}>
                                    <td className='littleRowAmazon'>AMZL</td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][0]} id='routes'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][1]} id='miles'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[4][2]} id='LWP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[4][3]} id='LVP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[4][12]} id='Jumper'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][4]} id='Training'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][5]} id='Support'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][6]} id='R2'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][7]} id='R4'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][8]} id='R6'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][9]} id='Missort 4th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][10]} id='Missort 6th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[4][11]} id='DPMO BONUS'/>
                                    </td>
                                    <td className='littleRowAmazonSave'>
                                    <button onClick={(e, dayName) => handleSaveData(e, 'Thursday')}>Save</button>
                                    </td>
                                </tr>
                            </tr>
                            <tr>
                                {/* {fridayRender} */}
                                <td className='bigRow'>Friday</td>
                                    <tr>
                                    </tr>
                                <tr onChange={handleFridayClick}>
                                    <td className='littleRowAmazon'>AMZL</td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][0]} id='routes'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][1]} id='miles'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[5][2]} id='LWP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[5][3]} id='LVP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[5][12]} id='Jumper'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][4]} id='Training'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][5]} id='Support'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][6]} id='R2'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][7]} id='R4'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][8]} id='R6'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][9]} id='Missort 4th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][10]} id='Missort 6th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[5][11]} id='DPMO BONUS'/>
                                    </td>
                                    <td className='littleRowAmazonSave'>
                                    <button onClick={(e, dayName) => handleSaveData(e, 'Friday')}>Save</button>
                                    </td>
                                </tr>
                            </tr>
                            <tr>
                                {/* {saturdayRender} */}
                                <td className='bigRow'>Saturday</td>
                                    <tr>
                                    </tr>
                                <tr onChange={handleSaturdayClick}>
                                    <td className='littleRowAmazon'>AMZL</td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][0]} id='routes'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][1]} id='miles'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[6][2]} id='LWP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[6][3]} id='LVP'/>
                                    </td>
                                    <td className='littleRowAmazon' >
                                        <input type="text" value={totalAmazonRoutes[6][12]} id='Jumper'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][4]} id='Training'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][5]} id='Support'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][6]} id='R2'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][7]} id='R4'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][8]} id='R6'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][9]} id='Missort 4th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][10]} id='Missort 6th'/>
                                    </td>
                                    <td className='littleRowAmazon'>
                                        <input type="text" value={totalAmazonRoutes[6][11]} id='DPMO BONUS'/>
                                    </td>
                                    <td className='littleRowAmazonSave'>
                                    <button onClick={(e, dayName) => handleSaveData(e, 'Saturday')}>Save</button>
                                    </td>
                                </tr>
                            </tr>
                            <tr>
                                {/* {totalRender} */}
                                <td className='bigRow'>Sums</td>
                                    <tr>

                                    </tr>
                                <tr>
                                    <td className='littleRowAmazonTotal'>AMZL</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[0]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[1]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[2]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[3]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[12]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[4]}</td>
                                    <td className='littleRowAmazonTotal'>{parseFloat(amazonTotals[5]).toFixed(2)}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[6]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[7]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[8]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[9]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[10]}</td>
                                    <td className='littleRowAmazonTotal'>{amazonTotals[11]}</td>
                                </tr>
                            </tr>
                            <br />
                            <tr>
                                {/* {sumsRow} */}
                                <tr>
                                </tr>
                            </tr>
                        </table>
                        <table>
                            {/* {finalSums} */}
                        </table>
                        <div className='bottomSection'>
                            {/* <table>
                                {finalSums}
                            </table> */}
                            { props.user_email !== "invoices@h2ologistics.co.uk" ? 
                            <div className='messageBox'>
                                <h3>Messages</h3>
                                <div className='messageBoxTextContainer'>
                                    {messages}
                                </div>
                                <button onClick={handleToggleMessageScreen}>Submit Message</button>
                            </div> : null}
                            {/* <div className='messageBox'>
                                <h3>Messages</h3>
                                <div className='messageBoxTextContainer'>
                                    {messages}
                                </div>
                                <button onClick={handleToggleMessageScreen}>Submit Message</button>
                            </div> */}
                        </div>
                    {/* <CSVLink data={xcelData} className='compliance_add_driver_button_submit' id='summary_button'>
                        <span className='span_in_complaince_button'>csv</span> 
                    </CSVLink>    */}
                    <br/>
                    </div>
                </div>
            </>
        )
    }
}
    

export default Statistics